module.exports = {
	"1/1:1-5": {
		"x": 71.97,
		"y": 71.4
	},
	"4/1:6-11": {
		"x": 69.71,
		"y": 84.71
	},
	"10/1:12-15": {
		"x": 55.72,
		"y": 47.51
	},
	"11/1:16-19": {
		"x": 96.95,
		"y": 72
	},
	"1/1:20-23": {
		"x": 43.14,
		"y": 50.76
	},
	"2/1:24-27": {
		"x": 84.82,
		"y": 67.35
	},
	"7/1:28-30": {
		"x": 57.42,
		"y": 80.52
	},
	"24/1:31": {
		"x": 40.07,
		"y": 62.88
	},
	"3/1:32-36": {
		"x": 81.64,
		"y": 91.9
	},
	"1/1:37-46": {
		"x": 44.45,
		"y": 85.77
	},
	"24/1:47-51": {
		"x": 71.13,
		"y": 47.53
	},
	"21/1:52": {
		"x": 70.56,
		"y": 97.68
	},
	"22/1:53": {
		"x": 75.24,
		"y": 59.34
	},
	"2/1:54": {
		"x": 94.36,
		"y": 45.84
	},
	"24/1:55-63": {
		"x": 57.57,
		"y": 94.01
	},
	"1/1:64-69": {
		"x": 63.44,
		"y": 36.44
	},
	"6/1:70": {
		"x": 81.57,
		"y": 79.4
	},
	"5/1:70": {
		"x": 51.68,
		"y": 59.88
	},
	"4/1:71": {
		"x": 83.28,
		"y": 50.45
	},
	"3/1:72": {
		"x": 59.76,
		"y": 68.77
	},
	"7/1:73": {
		"x": 36.42,
		"y": 74.3
	},
	"8/1:73": {
		"x": 92.74,
		"y": 83.77
	},
	"16/1:73": {
		"x": 48.14,
		"y": 71.76
	},
	"1/1:74": {
		"x": 63.42,
		"y": 57.34
	},
	"24/1:75-76": {
		"x": 92.81,
		"y": 57.74
	},
	"1/1:77": {
		"x": 46.76,
		"y": 38.8
	},
	"24/1:78": {
		"x": 80.14,
		"y": 38.87
	},
	"24/2:1": {
		"x": 165.96,
		"y": 80.24
	},
	"2/2:2": {
		"x": 206.6,
		"y": 70.15
	},
	"1/2:3": {
		"x": 200.72,
		"y": 90.08
	},
	"2/2:4-6": {
		"x": 189.31,
		"y": 42.45
	},
	"1/2:7": {
		"x": 218.11,
		"y": 73.55
	},
	"2/2:8-9": {
		"x": 195.09,
		"y": 66.75
	},
	"1/2:10": {
		"x": 198.36,
		"y": 34.57
	},
	"2/2:11-13": {
		"x": 232.08,
		"y": 89.61
	},
	"1/2:14": {
		"x": 180.53,
		"y": 94.97
	},
	"2/2:15-18": {
		"x": 191.94,
		"y": 54.65
	},
	"1/2:19": {
		"x": 220.91,
		"y": 85.21
	},
	"2/2:20": {
		"x": 215.3,
		"y": 61.89
	},
	"1/2:21-22": {
		"x": 212.48,
		"y": 50.22
	},
	"2/2:23": {
		"x": 209.41,
		"y": 81.81
	},
	"1/2:24": {
		"x": 168.6,
		"y": 47.26
	},
	"2/2:25": {
		"x": 221.18,
		"y": 41.96
	},
	"1/2:26": {
		"x": 168.95,
		"y": 91.85
	},
	"2/2:27": {
		"x": 218.95,
		"y": 30.16
	},
	"1/2:28": {
		"x": 201.16,
		"y": 46.24
	},
	"2/2:29": {
		"x": 162.85,
		"y": 68.66
	},
	"1/2:30": {
		"x": 235.49,
		"y": 57.02
	},
	"4/2:31-32": {
		"x": 189.22,
		"y": 86.7
	},
	"4/2:33": {
		"x": 187.01,
		"y": 30.68
	},
	"5/2:33": {
		"x": 186.39,
		"y": 75.05
	},
	"6/2:33": {
		"x": 174.45,
		"y": 71.77
	},
	"1/2:34": {
		"x": 232.68,
		"y": 45.35
	},
	"4/2:35-39": {
		"x": 203.76,
		"y": 102.67
	},
	"5/2:40-44": {
		"x": 171.31,
		"y": 59.46
	},
	"6/2:45-48": {
		"x": 230.51,
		"y": 77.21
	},
	"4/2:49-50": {
		"x": 177.7,
		"y": 83.31
	},
	"4/2:51": {
		"x": 203.8,
		"y": 58.5
	},
	"5/2:51": {
		"x": 197.9,
		"y": 78.42
	},
	"6/2:51": {
		"x": 180.13,
		"y": 50.6
	},
	"4/2:52": {
		"x": 223.98,
		"y": 53.62
	},
	"6/2:53": {
		"x": 192.03,
		"y": 98.35
	},
	"4/2:54": {
		"x": 177.88,
		"y": 38.82
	},
	"1/2:55-56": {
		"x": 223.38,
		"y": 97.86
	},
	"5/2:57": {
		"x": 183.14,
		"y": 63.5
	},
	"6/2:57": {
		"x": 209.86,
		"y": 37.98
	},
	"4/2:58": {
		"x": 212.22,
		"y": 93.47
	},
	"2/2:59": {
		"x": 226.8,
		"y": 65.28
	},
	"4/3:1-2": {
		"x": 373.42,
		"y": 63.71
	},
	"6/3:1-2": {
		"x": 323.82,
		"y": 109.71
	},
	"5/3:1-2": {
		"x": 343.35,
		"y": 80.43
	},
	"4/3:3": {
		"x": 327.69,
		"y": 64.14
	},
	"6/3:3": {
		"x": 286.71,
		"y": 88.32
	},
	"5/3:3": {
		"x": 361.67,
		"y": 92.47
	},
	"2/3:4-23": {
		"x": 339.51,
		"y": 106.59
	},
	"2/3:24": {
		"x": 364.36,
		"y": 112.9
	},
	"5/3:24": {
		"x": 330.17,
		"y": 16.43
	},
	"6/3:24": {
		"x": 325.87,
		"y": 52.3
	},
	"4/3:24": {
		"x": 338.4,
		"y": 69.51
	},
	"2/3:25-31": {
		"x": 370.2,
		"y": 78.55
	},
	"5/3:32": {
		"x": 344.85,
		"y": 41.47
	},
	"6/3:32": {
		"x": 362.31,
		"y": 68.22
	},
	"4/3:32": {
		"x": 316.39,
		"y": 60.13
	},
	"2/3:33-40": {
		"x": 310.97,
		"y": 19
	},
	"2/3:41-46": {
		"x": 355.41,
		"y": 57.2
	},
	"6/3:41-46": {
		"x": 356.38,
		"y": 80.62
	},
	"4/3:41-46": {
		"x": 334.84,
		"y": 90.26
	},
	"5/3:41-46": {
		"x": 348.67,
		"y": 92.28
	},
	"5/3:47-51": {
		"x": 282.59,
		"y": 60.2
	},
	"2/3:52": {
		"x": 391.44,
		"y": 60.94
	},
	"4/3:52": {
		"x": 297.63,
		"y": 75.27
	},
	"5/3:52": {
		"x": 350.14,
		"y": 30.72
	},
	"6/3:52": {
		"x": 369.09,
		"y": 101.88
	},
	"6/3:53-57": {
		"x": 314.32,
		"y": 47.55
	},
	"2/3:58": {
		"x": 350.32,
		"y": 69.12
	},
	"4/3:58": {
		"x": 308.61,
		"y": 80.12
	},
	"5/3:58": {
		"x": 322.64,
		"y": 25.76
	},
	"6/3:58": {
		"x": 330.22,
		"y": 78.12
	},
	"4/3:59-63": {
		"x": 320.4,
		"y": 85.83
	},
	"2/3:64": {
		"x": 371.69,
		"y": 41.84
	},
	"4/3:64": {
		"x": 332.93,
		"y": 42.6
	},
	"5/3:64": {
		"x": 294.59,
		"y": 63.67
	},
	"6/3:64": {
		"x": 362.12,
		"y": 30.08
	},
	"1/3:65-69": {
		"x": 304.5,
		"y": 56.04
	},
	"2/3:70-82": {
		"x": 340.07,
		"y": 55.17
	},
	"4/3:83": {
		"x": 324.22,
		"y": 97.73
	},
	"2/3:84-93": {
		"x": 283.66,
		"y": 74.66
	},
	"4/3:84-93": {
		"x": 336.25,
		"y": 29.03
	},
	"5/3:84-93": {
		"x": 330.36,
		"y": 122.08
	},
	"6/3:84-93": {
		"x": 308.46,
		"y": 34.29
	},
	"24/3:84-93": {
		"x": 384.04,
		"y": 72.82
	},
	"4/3:94-109": {
		"x": 298.54,
		"y": 102.22
	},
	"4/3:110-114": {
		"x": 343.59,
		"y": 16.53
	},
	"24/3:110-114": {
		"x": 356.01,
		"y": 103.61
	},
	"2/3:115-142": {
		"x": 290.8,
		"y": 43.64
	},
	"2/3:143-147": {
		"x": 383.69,
		"y": 38.41
	},
	"24/3:143-147": {
		"x": 318.85,
		"y": 72.95
	},
	"2/3:148-150": {
		"x": 322.02,
		"y": 37.74
	},
	"4/3:148-150": {
		"x": 374.06,
		"y": 90.95
	},
	"5/3:148-150": {
		"x": 298.65,
		"y": 87.21
	},
	"6/3:148-150": {
		"x": 374.12,
		"y": 30.1
	},
	"2/3:151": {
		"x": 352.68,
		"y": 115.66
	},
	"2/3:152-159": {
		"x": 296.15,
		"y": 24.89
	},
	"5/3:152-159": {
		"x": 381.18,
		"y": 52.18
	},
	"6/3:152-159": {
		"x": 312.34,
		"y": 116.8
	},
	"4/3:152-159": {
		"x": 358.24,
		"y": 43.01
	},
	"2/3:160": {
		"x": 367.71,
		"y": 53.16
	},
	"5/3:160": {
		"x": 309.61,
		"y": 92.07
	},
	"6/3:160": {
		"x": 355.59,
		"y": 20.03
	},
	"4/3:160": {
		"x": 313.64,
		"y": 103.37
	},
	"24/3:161": {
		"x": 307.29,
		"y": 68.2
	},
	"2/4:1": {
		"x": 486.22,
		"y": 68.42
	},
	"5/4:2": {
		"x": 467.89,
		"y": 86.41
	},
	"6/4:2": {
		"x": 487.17,
		"y": 36.61
	},
	"4/4:2": {
		"x": 480.78,
		"y": 101.03
	},
	"2/4:3": {
		"x": 437.31,
		"y": 75.15
	},
	"5/4:4": {
		"x": 494.33,
		"y": 59.58
	},
	"6/4:4": {
		"x": 451.14,
		"y": 60.52
	},
	"4/4:4": {
		"x": 451.96,
		"y": 28.79
	},
	"2/4:5": {
		"x": 502.42,
		"y": 82.22
	},
	"5/4:6": {
		"x": 470.94,
		"y": 54.27
	},
	"6/4:6": {
		"x": 455.6,
		"y": 40.22
	},
	"4/4:6": {
		"x": 458.15,
		"y": 93.41
	},
	"2/4:7": {
		"x": 474.54,
		"y": 65.72
	},
	"6/4:8": {
		"x": 497.92,
		"y": 71.1
	},
	"5/4:8": {
		"x": 439.5,
		"y": 63.37
	},
	"2/4:8": {
		"x": 463.72,
		"y": 31.4
	},
	"4/4:9-12": {
		"x": 490.01,
		"y": 80.78
	},
	"4/4:13": {
		"x": 466.38,
		"y": 74.53
	},
	"6/4:13": {
		"x": 467.34,
		"y": 42.83
	},
	"5/4:14": {
		"x": 469.09,
		"y": 98.34
	},
	"4/4:14": {
		"x": 447.51,
		"y": 49.09
	},
	"3/4:14": {
		"x": 506.02,
		"y": 62.26
	},
	"2/4:15": {
		"x": 425.69,
		"y": 78.12
	},
	"4/4:16-17": {
		"x": 490.76,
		"y": 48.06
	},
	"6/4:16-17": {
		"x": 445.01,
		"y": 84.34
	},
	"5/4:16-17": {
		"x": 435.86,
		"y": 51.94
	},
	"2/4:18": {
		"x": 462.83,
		"y": 63.09
	},
	"6/4:19": {
		"x": 446.49,
		"y": 96.25
	},
	"5/4:19": {
		"x": 459.22,
		"y": 51.65
	},
	"4/4:20": {
		"x": 490.83,
		"y": 93.25
	},
	"2/4:21": {
		"x": 427.88,
		"y": 66.33
	},
	"4/4:21": {
		"x": 479.05,
		"y": 45.44
	},
	"6/4:21": {
		"x": 456.67,
		"y": 81.52
	},
	"5/4:21": {
		"x": 448.97,
		"y": 72.32
	},
	"2/4:22": {
		"x": 478.06,
		"y": 77.19
	},
	"4/4:22": {
		"x": 433.4,
		"y": 87.31
	},
	"6/4:23": {
		"x": 475.46,
		"y": 34
	},
	"5/4:23": {
		"x": 479.57,
		"y": 89.09
	},
	"2/4:24-26": {
		"x": 443.87,
		"y": 37.66
	},
	"4/4:24-26": {
		"x": 502.45,
		"y": 50.75
	},
	"24/4:24-26": {
		"x": 459.35,
		"y": 105.35
	},
	"24/4:27": {
		"x": 482.64,
		"y": 56.89
	},
	"1/5:1-9": {
		"x": 645.25,
		"y": 73.83
	},
	"24/5:10": {
		"x": 563.33,
		"y": 63.02
	},
	"8/5:11": {
		"x": 617.54,
		"y": 38.43
	},
	"24/5:12": {
		"x": 621.04,
		"y": 81.65
	},
	"7/5:13": {
		"x": 580.34,
		"y": 89.94
	},
	"9/5:14": {
		"x": 634.26,
		"y": 65.41
	},
	"24/5:15-16": {
		"x": 570.88,
		"y": 82.52
	},
	"8/5:17": {
		"x": 574.59,
		"y": 43.72
	},
	"9/5:18": {
		"x": 563.21,
		"y": 48.29
	},
	"7/5:19": {
		"x": 552.11,
		"y": 67.6
	},
	"24/5:20": {
		"x": 582.05,
		"y": 63.1
	},
	"9/5:21": {
		"x": 590.77,
		"y": 98.21
	},
	"8/5:22": {
		"x": 611.85,
		"y": 73.96
	},
	"9/5:23": {
		"x": 632.24,
		"y": 77.39
	},
	"7/5:24": {
		"x": 581.99,
		"y": 78.08
	},
	"8/5:25-26": {
		"x": 623.05,
		"y": 69.69
	},
	"7/5:27": {
		"x": 611.94,
		"y": 107.13
	},
	"9/5:27": {
		"x": 606.34,
		"y": 42.7
	},
	"24/5:28": {
		"x": 602.57,
		"y": 66.37
	},
	"7/5:29": {
		"x": 584.51,
		"y": 112.7
	},
	"8/5:29": {
		"x": 597.02,
		"y": 35.13
	},
	"9/5:29": {
		"x": 627.69,
		"y": 102.79
	},
	"24/5:29": {
		"x": 585.81,
		"y": 39.41
	},
	"9/5:30": {
		"x": 624.96,
		"y": 57.84
	},
	"7/5:31": {
		"x": 600.63,
		"y": 78.19
	},
	"9/5:32": {
		"x": 576.51,
		"y": 31.85
	},
	"8/5:33": {
		"x": 646.03,
		"y": 60.36
	},
	"8/5:34": {
		"x": 604.44,
		"y": 54.53
	},
	"7/5:35": {
		"x": 608.22,
		"y": 30.86
	},
	"22/5:36": {
		"x": 613.75,
		"y": 62.11
	},
	"8/5:37-40": {
		"x": 564.69,
		"y": 35.89
	},
	"7/5:41-42": {
		"x": 626.85,
		"y": 45.99
	},
	"8/5:41-42": {
		"x": 615.64,
		"y": 50.27
	},
	"9/5:41-42": {
		"x": 591.35,
		"y": 70.64
	},
	"1/5:43-48": {
		"x": 641.39,
		"y": 87.8
	},
	"8/5:49": {
		"x": 572.73,
		"y": 55.57
	},
	"1/5:50-51": {
		"x": 610.13,
		"y": 19.01
	},
	"8/5:52-55": {
		"x": 617.31,
		"y": 95.85
	},
	"7/5:56-57": {
		"x": 591.75,
		"y": 86.26
	},
	"8/5:56-57": {
		"x": 593.25,
		"y": 58.81
	},
	"9/5:56-57": {
		"x": 569.2,
		"y": 94.39
	},
	"8/5:58-59": {
		"x": 598.92,
		"y": 23.29
	},
	"21/5:60": {
		"x": 609.82,
		"y": 85.84
	},
	"7/5:61-62": {
		"x": 553.8,
		"y": 55.72
	},
	"7/5:63-64": {
		"x": 628.74,
		"y": 34.15
	},
	"9/5:63-64": {
		"x": 579.35,
		"y": 101.87
	},
	"7/5:65-66": {
		"x": 583.92,
		"y": 51.25
	},
	"8/5:65-66": {
		"x": 636.15,
		"y": 53.56
	},
	"9/5:65-66": {
		"x": 559.73,
		"y": 86.92
	},
	"24/5:67": {
		"x": 595.12,
		"y": 46.96
	},
	"8/5:68-72": {
		"x": 603.13,
		"y": 96.38
	},
	"8/5:73-74": {
		"x": 572.66,
		"y": 70.55
	},
	"7/5:73-74": {
		"x": 638.05,
		"y": 41.71
	},
	"9/5:73-74": {
		"x": 568.21,
		"y": 106.35
	},
	"24/5:75-76": {
		"x": 587.71,
		"y": 27.57
	},
	"21/5:77": {
		"x": 628.75,
		"y": 90.84
	},
	"22/5:78": {
		"x": 561.53,
		"y": 75.03
	},
	"24/5:79": {
		"x": 619.43,
		"y": 26.58
	},
	"24/5:80-90": {
		"x": 598.25,
		"y": 110.04
	},
	"13/6:1-4": {
		"x": 726.21,
		"y": 60.3
	},
	"6/6:5": {
		"x": 737.05,
		"y": 66.52
	},
	"13/6:6-8": {
		"x": 726.45,
		"y": 72.79
	},
	"1/6:9": {
		"x": 737.43,
		"y": 42.39
	},
	"13/6:10-12": {
		"x": 747.72,
		"y": 84.56
	},
	"2/6:13-25": {
		"x": 713,
		"y": 67.39
	},
	"13/6:26": {
		"x": 747.49,
		"y": 60.57
	},
	"2/6:27": {
		"x": 737.31,
		"y": 90.52
	},
	"13/6:28": {
		"x": 726.72,
		"y": 47.82
	},
	"2/6:28": {
		"x": 747.42,
		"y": 72.57
	},
	"2/6:29": {
		"x": 715.17,
		"y": 81.73
	},
	"13/6:30": {
		"x": 747.71,
		"y": 48.58
	},
	"2/6:31-32": {
		"x": 737,
		"y": 78.52
	},
	"1/6:33": {
		"x": 715.93,
		"y": 53.2
	},
	"2/6:34": {
		"x": 757.84,
		"y": 66.64
	},
	"24/6:35-36": {
		"x": 726.77,
		"y": 84.79
	},
	"24/6:37": {
		"x": 737.21,
		"y": 54.39
	},
	"12/7:1-40": {
		"x": 70.19,
		"y": 200.09
	},
	"24/7:41-44": {
		"x": 49.21,
		"y": 199.16
	},
	"24/8:1-2": {
		"x": 250.9,
		"y": 164.84
	},
	"24/8:3-6": {
		"x": 165.68,
		"y": 232.13
	},
	"2/8:7-9": {
		"x": 252.51,
		"y": 208.01
	},
	"2/8:10": {
		"x": 234.6,
		"y": 192.07
	},
	"1/8:10": {
		"x": 196.78,
		"y": 136.19
	},
	"4/8:10": {
		"x": 230.57,
		"y": 160.58
	},
	"6/8:10": {
		"x": 227.34,
		"y": 227.28
	},
	"5/8:10": {
		"x": 147.93,
		"y": 192.78
	},
	"2/8:11-12": {
		"x": 257.39,
		"y": 184.55
	},
	"2/8:13": {
		"x": 157.88,
		"y": 199.45
	},
	"1/8:13": {
		"x": 207.07,
		"y": 223.22
	},
	"4/8:13": {
		"x": 195.94,
		"y": 172.07
	},
	"6/8:13": {
		"x": 193.65,
		"y": 254.5
	},
	"5/8:13": {
		"x": 167.69,
		"y": 206.28
	},
	"2/8:14-16": {
		"x": 216.71,
		"y": 176.04
	},
	"2/8:17": {
		"x": 159.9,
		"y": 162.69
	},
	"1/8:17": {
		"x": 243.54,
		"y": 200.04
	},
	"4/8:17": {
		"x": 148.77,
		"y": 180.82
	},
	"6/8:17": {
		"x": 208.16,
		"y": 132.39
	},
	"5/8:17": {
		"x": 222.4,
		"y": 252.38
	},
	"2/8:18": {
		"x": 193.16,
		"y": 242.54
	},
	"2/8:19": {
		"x": 168.86,
		"y": 194.36
	},
	"1/8:19": {
		"x": 187.03,
		"y": 232.26
	},
	"4/8:19": {
		"x": 250.07,
		"y": 219.75
	},
	"6/8:19": {
		"x": 205.25,
		"y": 179.64
	},
	"5/8:19": {
		"x": 174.64,
		"y": 144.64
	},
	"2/8:20": {
		"x": 179.79,
		"y": 189.41
	},
	"24/8:21": {
		"x": 239.5,
		"y": 168.58
	},
	"1/8:22": {
		"x": 137.86,
		"y": 185.77
	},
	"24/8:23": {
		"x": 210.22,
		"y": 156.26
	},
	"1/8:24": {
		"x": 182.76,
		"y": 248.47
	},
	"24/8:25": {
		"x": 197.81,
		"y": 148.13
	},
	"1/8:26": {
		"x": 188.37,
		"y": 208.34
	},
	"24/8:27": {
		"x": 159.52,
		"y": 175.57
	},
	"1/8:28": {
		"x": 176.61,
		"y": 238.18
	},
	"3/8:29-45": {
		"x": 208.5,
		"y": 244.63
	},
	"24/8:46": {
		"x": 186.08,
		"y": 150.61
	},
	"3/8:47-58": {
		"x": 237.06,
		"y": 237.38
	},
	"2/8:59": {
		"x": 177.43,
		"y": 213.23
	},
	"6/8:60": {
		"x": 187.14,
		"y": 162.55
	},
	"2/8:61": {
		"x": 216.01,
		"y": 231.06
	},
	"6/8:62": {
		"x": 169.79,
		"y": 169.46
	},
	"2/8:63-65": {
		"x": 241.12,
		"y": 211.75
	},
	"6/8:66": {
		"x": 211.71,
		"y": 199.53
	},
	"3/8:67": {
		"x": 209.17,
		"y": 144.33
	},
	"24/8:68": {
		"x": 229.74,
		"y": 215.53
	},
	"3/8:69": {
		"x": 135.87,
		"y": 211.24
	},
	"24/8:70": {
		"x": 233.02,
		"y": 148.84
	},
	"3/8:71": {
		"x": 201.52,
		"y": 263.53
	},
	"24/8:72": {
		"x": 167.01,
		"y": 219.1
	},
	"3/8:73": {
		"x": 238.68,
		"y": 223.51
	},
	"24/8:74": {
		"x": 209.33,
		"y": 211.44
	},
	"3/8:75-84": {
		"x": 182.31,
		"y": 175.67
	},
	"1/8:85": {
		"x": 199.02,
		"y": 232.06
	},
	"3/8:86": {
		"x": 159.01,
		"y": 187.54
	},
	"1/8:87-88": {
		"x": 170.05,
		"y": 182.41
	},
	"3/8:89": {
		"x": 172.62,
		"y": 254.9
	},
	"1/8:90-96": {
		"x": 175.14,
		"y": 157.61
	},
	"3/8:97": {
		"x": 220.69,
		"y": 207.56
	},
	"1/8:98-99": {
		"x": 156.12,
		"y": 224.11
	},
	"3/8:100": {
		"x": 221.63,
		"y": 152.58
	},
	"1/8:101": {
		"x": 218.37,
		"y": 219.32
	},
	"2/8:102": {
		"x": 193.62,
		"y": 183.84
	},
	"3/8:103": {
		"x": 254.94,
		"y": 196.29
	},
	"2/8:104": {
		"x": 237.05,
		"y": 180.32
	},
	"2/8:105": {
		"x": 198.84,
		"y": 160.06
	},
	"1/8:105": {
		"x": 207.79,
		"y": 168.03
	},
	"1/8:106": {
		"x": 178.63,
		"y": 201.33
	},
	"3/8:107": {
		"x": 219.19,
		"y": 164.3
	},
	"1/8:108": {
		"x": 183.25,
		"y": 260.46
	},
	"3/8:109": {
		"x": 190.2,
		"y": 195.36
	},
	"2/8:110": {
		"x": 248.44,
		"y": 176.57
	},
	"3/8:111-113": {
		"x": 198.02,
		"y": 215.6
	},
	"2/8:114": {
		"x": 223.43,
		"y": 240.48
	},
	"3/8:115": {
		"x": 234.32,
		"y": 251.1
	},
	"2/8:116": {
		"x": 136.85,
		"y": 197.73
	},
	"3/8:117-119": {
		"x": 245.99,
		"y": 188.32
	},
	"2/8:120": {
		"x": 157.24,
		"y": 212.15
	},
	"3/8:121": {
		"x": 185.05,
		"y": 138.67
	},
	"2/8:122": {
		"x": 249.52,
		"y": 243.74
	},
	"3/8:123-125": {
		"x": 202.93,
		"y": 191.29
	},
	"2/8:126": {
		"x": 223.2,
		"y": 195.83
	},
	"3/8:127": {
		"x": 226.71,
		"y": 263.55
	},
	"2/8:128": {
		"x": 176.63,
		"y": 226.21
	},
	"3/8:129-132": {
		"x": 199.8,
		"y": 203.37
	},
	"24/8:133-135": {
		"x": 154.47,
		"y": 237.63
	},
	"2/8:136": {
		"x": 214.29,
		"y": 187.77
	},
	"3/8:137": {
		"x": 249.86,
		"y": 231.74
	},
	"3/8:138": {
		"x": 145.98,
		"y": 217.7
	},
	"24/8:138": {
		"x": 228.12,
		"y": 172.32
	},
	"2/8:139-141": {
		"x": 212.86,
		"y": 259.61
	},
	"3/8:142": {
		"x": 149.61,
		"y": 168.85
	},
	"24/8:142": {
		"x": 232.15,
		"y": 203.8
	},
	"2/8:143-146": {
		"x": 146.83,
		"y": 205.23
	},
	"24/8:147": {
		"x": 220.59,
		"y": 140.64
	},
	"2/8:148-149": {
		"x": 225.7,
		"y": 184.07
	},
	"24/8:150": {
		"x": 187.07,
		"y": 220.3
	},
	"2/8:151": {
		"x": 241.96,
		"y": 156.84
	},
	"24/8:152": {
		"x": 166.48,
		"y": 244.59
	},
	"2/8:153": {
		"x": 163.76,
		"y": 151.33
	},
	"3/8:154": {
		"x": 261.45,
		"y": 216
	},
	"24/8:155": {
		"x": 145.49,
		"y": 229.68
	},
	"1/9:1-8": {
		"x": 334.92,
		"y": 182.48
	},
	"22/9:9": {
		"x": 338.74,
		"y": 216.94
	},
	"1/9:10": {
		"x": 332.36,
		"y": 196.11
	},
	"22/9:11": {
		"x": 352.6,
		"y": 200.81
	},
	"1/9:12": {
		"x": 318.5,
		"y": 212.24
	},
	"22/9:13": {
		"x": 322.93,
		"y": 188.68
	},
	"1/9:14-15": {
		"x": 341.12,
		"y": 204.3
	},
	"2/9:16": {
		"x": 321.21,
		"y": 200.56
	},
	"24/9:17": {
		"x": 343.84,
		"y": 192.62
	},
	"1/9:18-19": {
		"x": 329.98,
		"y": 208.75
	},
	"1/9:20": {
		"x": 311.79,
		"y": 193.13
	},
	"2/9:21": {
		"x": 349.88,
		"y": 212.5
	},
	"2/10:1-3": {
		"x": 452.44,
		"y": 213.37
	},
	"1/10:1-3": {
		"x": 468.36,
		"y": 185.91
	},
	"4/10:1-3": {
		"x": 457.02,
		"y": 189.81
	},
	"2/10:4": {
		"x": 436.61,
		"y": 185.85
	},
	"1/10:4": {
		"x": 495.76,
		"y": 184.04
	},
	"4/10:4": {
		"x": 463.78,
		"y": 209.46
	},
	"21/10:4": {
		"x": 447.96,
		"y": 181.95
	},
	"7/10:5-8": {
		"x": 499.01,
		"y": 202.2
	},
	"7/10:9-11": {
		"x": 443.38,
		"y": 205.5
	},
	"21/10:9-11": {
		"x": 483.77,
		"y": 183.62
	},
	"7/10:12-17": {
		"x": 462.19,
		"y": 234.21
	},
	"7/10:18": {
		"x": 446.64,
		"y": 170.03
	},
	"21/10:18": {
		"x": 487.1,
		"y": 205.98
	},
	"7/10:19-31": {
		"x": 448.33,
		"y": 227.27
	},
	"2/10:32": {
		"x": 459.3,
		"y": 178.04
	},
	"8/10:33": {
		"x": 484.32,
		"y": 235.65
	},
	"2/10:34": {
		"x": 445.67,
		"y": 193.72
	},
	"7/10:35": {
		"x": 466.06,
		"y": 197.68
	},
	"2/10:36": {
		"x": 474.19,
		"y": 229.23
	},
	"8/10:37": {
		"x": 457.98,
		"y": 166.12
	},
	"7/10:38": {
		"x": 489.4,
		"y": 194.21
	},
	"2/10:39": {
		"x": 438.62,
		"y": 216.5
	},
	"8/10:40": {
		"x": 475.12,
		"y": 205.55
	},
	"7/10:41": {
		"x": 472.84,
		"y": 217.31
	},
	"21/10:41": {
		"x": 454.72,
		"y": 201.59
	},
	"7/10:42-44": {
		"x": 477.41,
		"y": 193.78
	},
	"8/10:45": {
		"x": 461.5,
		"y": 221.22
	},
	"7/10:46-67": {
		"x": 473.92,
		"y": 170.39
	},
	"2/10:68-83": {
		"x": 487.38,
		"y": 220.97
	},
	"21/10:84-86": {
		"x": 434.33,
		"y": 197.63
	},
	"7/10:87": {
		"x": 490.13,
		"y": 173.45
	},
	"4/11:1-3": {
		"x": 610.67,
		"y": 240.48
	},
	"8/11:4-23": {
		"x": 579.51,
		"y": 176.26
	},
	"24/11:24": {
		"x": 622.54,
		"y": 211.05
	},
	"2/11:25": {
		"x": 570.88,
		"y": 222.41
	},
	"8/11:26": {
		"x": 606.89,
		"y": 197.42
	},
	"2/11:27": {
		"x": 610.78,
		"y": 208.74
	},
	"8/11:28": {
		"x": 583.61,
		"y": 191.71
	},
	"2/11:29": {
		"x": 630.42,
		"y": 202
	},
	"8/11:30": {
		"x": 583.18,
		"y": 224.48
	},
	"2/11:31": {
		"x": 593.65,
		"y": 168.79
	},
	"8/11:32": {
		"x": 626.44,
		"y": 222.39
	},
	"2/11:33-34": {
		"x": 591.11,
		"y": 215.5
	},
	"8/11:35-51": {
		"x": 612.09,
		"y": 182.84
	},
	"7/11:52": {
		"x": 602.89,
		"y": 217.78
	},
	"8/11:53": {
		"x": 571.71,
		"y": 190.24
	},
	"7/11:54": {
		"x": 637.67,
		"y": 192.45
	},
	"8/11:55": {
		"x": 587.1,
		"y": 235.85
	},
	"7/11:56": {
		"x": 595.25,
		"y": 194.61
	},
	"8/11:57": {
		"x": 606.78,
		"y": 229.14
	},
	"8/11:58": {
		"x": 562.96,
		"y": 198.45
	},
	"24/11:58": {
		"x": 625.79,
		"y": 190.08
	},
	"2/11:59": {
		"x": 598.89,
		"y": 238.18
	},
	"8/11:60": {
		"x": 584.49,
		"y": 161.06
	},
	"2/11:61": {
		"x": 634.32,
		"y": 213.35
	},
	"24/11:62": {
		"x": 574.43,
		"y": 201.92
	},
	"8/11:63-70": {
		"x": 624.53,
		"y": 171.26
	},
	"7/11:71": {
		"x": 618.56,
		"y": 231.44
	},
	"2/11:72": {
		"x": 564.19,
		"y": 180.89
	},
	"8/11:73": {
		"x": 599,
		"y": 206.44
	},
	"24/11:74": {
		"x": 575.33,
		"y": 233.55
	},
	"8/11:75-81": {
		"x": 595.64,
		"y": 181.63
	},
	"7/11:82": {
		"x": 614.66,
		"y": 220.09
	},
	"2/11:83": {
		"x": 566.77,
		"y": 211.14
	},
	"8/11:84": {
		"x": 633.76,
		"y": 181.11
	},
	"24/11:85": {
		"x": 595.01,
		"y": 226.82
	},
	"8/11:86-90": {
		"x": 586.79,
		"y": 203.79
	},
	"8/11:91": {
		"x": 618.65,
		"y": 199.71
	},
	"24/11:91": {
		"x": 578.73,
		"y": 213.34
	},
	"8/11:92-111": {
		"x": 608.79,
		"y": 163.62
	},
	"4/12:1": {
		"x": 756.42,
		"y": 232.91
	},
	"6/12:2": {
		"x": 760.65,
		"y": 221.69
	},
	"5/12:2": {
		"x": 753.88,
		"y": 180.71
	},
	"4/12:3": {
		"x": 741.2,
		"y": 214.38
	},
	"6/12:4": {
		"x": 707.25,
		"y": 156.95
	},
	"5/12:4": {
		"x": 748.82,
		"y": 223.64
	},
	"4/12:5": {
		"x": 696.5,
		"y": 210.3
	},
	"6/12:6": {
		"x": 750.47,
		"y": 160.21
	},
	"5/12:6": {
		"x": 750.64,
		"y": 243.42
	},
	"4/12:7": {
		"x": 703.04,
		"y": 168.18
	},
	"5/12:8": {
		"x": 745.43,
		"y": 203.16
	},
	"4/12:9-10": {
		"x": 731.19,
		"y": 236.11
	},
	"6/12:9-10": {
		"x": 731.01,
		"y": 152.93
	},
	"6/12:11": {
		"x": 727.8,
		"y": 215.61
	},
	"5/12:12": {
		"x": 693,
		"y": 189.89
	},
	"4/12:13": {
		"x": 730.21,
		"y": 184.64
	},
	"5/12:14": {
		"x": 723.59,
		"y": 226.84
	},
	"2/12:14": {
		"x": 714.96,
		"y": 166.13
	},
	"6/12:15": {
		"x": 764.88,
		"y": 210.47
	},
	"2/12:16": {
		"x": 699.92,
		"y": 230.78
	},
	"4/12:16": {
		"x": 725.99,
		"y": 195.86
	},
	"5/12:16": {
		"x": 742.04,
		"y": 182.67
	},
	"5/12:17": {
		"x": 722.6,
		"y": 175.39
	},
	"4/12:18": {
		"x": 757.27,
		"y": 201.21
	},
	"2/12:19": {
		"x": 711.75,
		"y": 228.81
	},
	"1/12:20": {
		"x": 753.04,
		"y": 212.43
	},
	"2/12:21": {
		"x": 772.49,
		"y": 219.74
	},
	"1/12:22": {
		"x": 688.79,
		"y": 201.13
	},
	"6/12:23": {
		"x": 746.26,
		"y": 171.45
	},
	"5/12:23": {
		"x": 743.03,
		"y": 234.15
	},
	"1/12:24": {
		"x": 710.76,
		"y": 177.35
	},
	"6/12:25": {
		"x": 749.66,
		"y": 191.93
	},
	"1/12:26": {
		"x": 708.34,
		"y": 208.32
	},
	"5/12:27": {
		"x": 726.8,
		"y": 164.16
	},
	"2/12:28-29": {
		"x": 735.42,
		"y": 224.87
	},
	"1/12:30": {
		"x": 700.71,
		"y": 199.07
	},
	"2/12:31": {
		"x": 765.71,
		"y": 178.75
	},
	"1/12:32-33": {
		"x": 726.97,
		"y": 247.34
	},
	"4/12:34-35": {
		"x": 737.83,
		"y": 193.9
	},
	"2/12:36": {
		"x": 776.71,
		"y": 208.51
	},
	"4/12:37": {
		"x": 712.56,
		"y": 197.1
	},
	"1/12:38": {
		"x": 734.43,
		"y": 173.42
	},
	"2/12:39": {
		"x": 738.81,
		"y": 245.37
	},
	"5/12:40": {
		"x": 733.6,
		"y": 205.13
	},
	"4/12:41": {
		"x": 761.48,
		"y": 189.97
	},
	"2/12:42": {
		"x": 719.36,
		"y": 238.07
	},
	"6/12:43": {
		"x": 719.17,
		"y": 154.9
	},
	"2/12:44": {
		"x": 715.97,
		"y": 217.58
	},
	"1/12:45": {
		"x": 720.19,
		"y": 206.35
	},
	"2/12:46": {
		"x": 758.09,
		"y": 169.48
	},
	"1/12:47": {
		"x": 718.38,
		"y": 186.62
	},
	"2/12:48": {
		"x": 697.21,
		"y": 178.66
	},
	"1/12:49": {
		"x": 769.1,
		"y": 199.25
	},
	"2/12:50": {
		"x": 704.13,
		"y": 219.55
	},
	"1/12:51-52": {
		"x": 738.64,
		"y": 162.18
	},
	"2/12:53-54": {
		"x": 768.25,
		"y": 230.96
	},
	"1/12:55": {
		"x": 704.94,
		"y": 187.84
	},
	"2/12:56": {
		"x": 773.33,
		"y": 188.01
	},
	"1/13:1-25": {
		"x": 58.61,
		"y": 342.71
	},
	"1/13:26-38": {
		"x": 66.41,
		"y": 303.38
	},
	"24/13:26-38": {
		"x": 74.98,
		"y": 332.12
	},
	"24/13:39-41": {
		"x": 42.47,
		"y": 337.38
	},
	"1/13:42": {
		"x": 83.31,
		"y": 320.25
	},
	"24/13:43-46": {
		"x": 51.61,
		"y": 358.75
	},
	"1/13:47-48": {
		"x": 50.01,
		"y": 328.05
	},
	"24/13:49-52": {
		"x": 94.58,
		"y": 325.65
	},
	"1/13:53": {
		"x": 42.97,
		"y": 349.37
	},
	"24/13:54-57": {
		"x": 71.09,
		"y": 317.63
	},
	"1/13:58-59": {
		"x": 94.87,
		"y": 348.44
	},
	"24/13:60-62": {
		"x": 38.15,
		"y": 326.18
	},
	"1/13:63": {
		"x": 57.52,
		"y": 314.83
	},
	"24/13:64-66": {
		"x": 64.11,
		"y": 358.79
	},
	"1/13:67-68": {
		"x": 45.69,
		"y": 316.85
	},
	"24/13:69-72": {
		"x": 89.01,
		"y": 337.39
	},
	"1/13:73-74": {
		"x": 61.83,
		"y": 326.02
	},
	"24/13:75-77": {
		"x": 79.88,
		"y": 308.75
	},
	"1/13:78-98": {
		"x": 78.53,
		"y": 350.78
	},
	"7/14:1": {
		"x": 195.98,
		"y": 320.26
	},
	"7/14:2": {
		"x": 213.58,
		"y": 331.27
	},
	"8/14:2": {
		"x": 183.27,
		"y": 340.62
	},
	"21/14:2": {
		"x": 172.01,
		"y": 319.42
	},
	"2/14:3-8": {
		"x": 202.66,
		"y": 353.56
	},
	"3/14:9": {
		"x": 159.23,
		"y": 339.72
	},
	"2/14:10": {
		"x": 216.94,
		"y": 312.74
	},
	"3/14:11-12": {
		"x": 206.35,
		"y": 366.01
	},
	"2/14:13": {
		"x": 196.73,
		"y": 299.51
	},
	"3/14:14-15": {
		"x": 233.76,
		"y": 343.21
	},
	"2/14:16": {
		"x": 170.43,
		"y": 360.93
	},
	"3/14:17": {
		"x": 211.32,
		"y": 302.15
	},
	"2/14:18": {
		"x": 225.91,
		"y": 365.28
	},
	"3/14:19": {
		"x": 183.99,
		"y": 319.84
	},
	"2/14:20": {
		"x": 240.3,
		"y": 317
	},
	"3/14:21": {
		"x": 207.24,
		"y": 341.42
	},
	"2/14:22": {
		"x": 166.38,
		"y": 308.82
	},
	"3/14:23-24": {
		"x": 224.93,
		"y": 335.1
	},
	"2/14:25": {
		"x": 171.28,
		"y": 340.18
	},
	"4/14:25": {
		"x": 207.97,
		"y": 320.69
	},
	"5/14:25": {
		"x": 177.63,
		"y": 330.01
	},
	"6/14:26": {
		"x": 178.37,
		"y": 309.25
	},
	"5/14:27": {
		"x": 201.6,
		"y": 330.84
	},
	"4/14:28-30": {
		"x": 182.34,
		"y": 362.35
	},
	"2/14:31-35": {
		"x": 191.14,
		"y": 288.34
	},
	"3/14:36": {
		"x": 237.27,
		"y": 360.21
	},
	"2/14:37-41": {
		"x": 189.28,
		"y": 351.98
	},
	"14/14:42": {
		"x": 228.92,
		"y": 313.18
	},
	"2/14:43": {
		"x": 187.32,
		"y": 373.26
	},
	"2/14:44": {
		"x": 190.35,
		"y": 309.68
	},
	"4/14:44": {
		"x": 243.62,
		"y": 350.03
	},
	"5/14:44": {
		"x": 176.85,
		"y": 350.8
	},
	"3/14:45": {
		"x": 205.69,
		"y": 291.55
	},
	"14/14:46": {
		"x": 218.58,
		"y": 345.27
	},
	"3/14:47": {
		"x": 165.65,
		"y": 329.58
	},
	"14/14:48": {
		"x": 233.93,
		"y": 327.17
	},
	"3/14:49": {
		"x": 175.28,
		"y": 372.04
	},
	"14/14:50": {
		"x": 172.75,
		"y": 298.65
	},
	"3/14:51": {
		"x": 242.76,
		"y": 335.28
	},
	"3/14:52": {
		"x": 164.86,
		"y": 350.31
	},
	"2/14:53": {
		"x": 222.56,
		"y": 323.34
	},
	"3/14:54": {
		"x": 195.26,
		"y": 341.01
	},
	"2/14:55": {
		"x": 184.74,
		"y": 299.08
	},
	"4/14:56": {
		"x": 189.6,
		"y": 330.43
	},
	"5/14:57": {
		"x": 199.1,
		"y": 375.56
	},
	"2/14:58-60": {
		"x": 223.3,
		"y": 302.58
	},
	"14/14:61-64": {
		"x": 215.59,
		"y": 357.42
	},
	"24/14:65": {
		"x": 160.02,
		"y": 318.99
	},
	"3/14:66": {
		"x": 235.29,
		"y": 303.02
	},
	"2/14:67": {
		"x": 194.29,
		"y": 363.49
	},
	"3/14:68": {
		"x": 202.34,
		"y": 310.1
	},
	"4/14:69": {
		"x": 227.42,
		"y": 353.38
	},
	"2/14:70": {
		"x": 158.45,
		"y": 360.45
	},
	"4/14:71-72": {
		"x": 217.68,
		"y": 291.98
	},
	"2/14:73": {
		"x": 216.39,
		"y": 372.58
	},
	"22/15:1": {
		"x": 337.36,
		"y": 321.26
	},
	"24/15:2": {
		"x": 368.49,
		"y": 327.42
	},
	"1/15:3": {
		"x": 306.04,
		"y": 351.08
	},
	"2/15:3": {
		"x": 327.07,
		"y": 303.21
	},
	"4/15:3": {
		"x": 357.95,
		"y": 357.36
	},
	"14/15:3": {
		"x": 295.74,
		"y": 333.04
	},
	"24/15:4-5": {
		"x": 347.71,
		"y": 327.31
	},
	"4/15:6-7": {
		"x": 305.98,
		"y": 363.08
	},
	"24/15:8": {
		"x": 316.65,
		"y": 309.16
	},
	"4/15:9": {
		"x": 347.59,
		"y": 351.3
	},
	"2/15:10": {
		"x": 326.88,
		"y": 339.2
	},
	"24/15:11": {
		"x": 337.48,
		"y": 297.27
	},
	"14/15:12": {
		"x": 337.24,
		"y": 345.25
	},
	"1/15:13": {
		"x": 306.17,
		"y": 327.1
	},
	"2/15:14": {
		"x": 368.56,
		"y": 315.43
	},
	"1/15:15": {
		"x": 337.17,
		"y": 357.24
	},
	"24/15:16-17": {
		"x": 316.72,
		"y": 297.16
	},
	"4/15:18-19": {
		"x": 358.01,
		"y": 345.36
	},
	"2/15:20": {
		"x": 295.69,
		"y": 345.03
	},
	"1/15:21": {
		"x": 347.84,
		"y": 303.32
	},
	"24/15:22": {
		"x": 347.65,
		"y": 339.31
	},
	"14/15:23": {
		"x": 295.81,
		"y": 321.04
	},
	"24/15:24-25": {
		"x": 358.13,
		"y": 321.37
	},
	"2/15:26-27": {
		"x": 326.76,
		"y": 363.19
	},
	"24/15:28": {
		"x": 337.42,
		"y": 309.27
	},
	"14/15:29-30": {
		"x": 357.88,
		"y": 369.35
	},
	"24/15:31": {
		"x": 316.53,
		"y": 333.15
	},
	"4/15:32-33": {
		"x": 358.2,
		"y": 309.38
	},
	"14/15:32-33": {
		"x": 337.1,
		"y": 369.25
	},
	"2/15:32-33": {
		"x": 306.29,
		"y": 303.1
	},
	"1/15:32-33": {
		"x": 358.07,
		"y": 333.37
	},
	"1/15:34": {
		"x": 306.1,
		"y": 339.09
	},
	"2/15:35": {
		"x": 337.3,
		"y": 333.25
	},
	"1/15:36": {
		"x": 347.52,
		"y": 363.29
	},
	"2/15:37-38": {
		"x": 316.46,
		"y": 345.14
	},
	"1/15:39": {
		"x": 347.78,
		"y": 315.32
	},
	"2/15:40": {
		"x": 316.33,
		"y": 369.13
	},
	"2/15:41": {
		"x": 327.01,
		"y": 315.21
	},
	"24/15:42": {
		"x": 368.36,
		"y": 351.41
	},
	"2/15:43-44": {
		"x": 316.59,
		"y": 321.16
	},
	"22/15:45-46": {
		"x": 358.26,
		"y": 297.38
	},
	"2/15:47": {
		"x": 326.82,
		"y": 351.19
	},
	"1/15:47": {
		"x": 306.23,
		"y": 315.1
	},
	"24/15:48": {
		"x": 368.43,
		"y": 339.42
	},
	"2/15:49": {
		"x": 316.4,
		"y": 357.14
	},
	"1/15:49": {
		"x": 326.94,
		"y": 327.21
	},
	"2/16:1": {
		"x": 475.39,
		"y": 346.76
	},
	"1/16:2-3": {
		"x": 442.16,
		"y": 319.08
	},
	"4/16:4": {
		"x": 473.11,
		"y": 326.11
	},
	"1/16:5": {
		"x": 465.74,
		"y": 368.73
	},
	"2/16:6": {
		"x": 458.9,
		"y": 306.78
	},
	"24/16:7": {
		"x": 492.13,
		"y": 334.46
	},
	"1/16:8": {
		"x": 439.62,
		"y": 350.71
	},
	"3/16:9-10": {
		"x": 477.93,
		"y": 315.13
	},
	"1/16:11": {
		"x": 477.67,
		"y": 367.41
	},
	"3/16:12-14": {
		"x": 451.8,
		"y": 297.11
	},
	"1/16:15": {
		"x": 468.29,
		"y": 337.09
	},
	"3/16:16": {
		"x": 446.72,
		"y": 360.38
	},
	"2/16:17": {
		"x": 466.01,
		"y": 316.45
	},
	"3/16:18": {
		"x": 482.49,
		"y": 356.43
	},
	"24/16:19-20": {
		"x": 432.51,
		"y": 341.05
	},
	"3/16:21": {
		"x": 489.85,
		"y": 313.81
	},
	"2/16:22": {
		"x": 458.64,
		"y": 359.07
	},
	"3/16:23": {
		"x": 446.98,
		"y": 308.1
	},
	"2/16:24": {
		"x": 480.2,
		"y": 335.78
	},
	"3/16:25": {
		"x": 456.36,
		"y": 338.41
	},
	"2/16:26-27": {
		"x": 470.83,
		"y": 305.47
	},
	"3/16:28": {
		"x": 494.41,
		"y": 355.11
	},
	"2/16:29": {
		"x": 449.26,
		"y": 328.75
	},
	"3/16:30-31": {
		"x": 485.03,
		"y": 324.79
	},
	"2/16:32-34": {
		"x": 463.46,
		"y": 348.08
	},
	"3/16:35": {
		"x": 463.73,
		"y": 295.8
	},
	"2/16:36-38": {
		"x": 487.31,
		"y": 345.44
	},
	"3/16:39": {
		"x": 444.44,
		"y": 339.73
	},
	"2/16:40": {
		"x": 461.19,
		"y": 327.43
	},
	"3/16:41": {
		"x": 470.57,
		"y": 357.74
	},
	"2/16:42": {
		"x": 454.08,
		"y": 317.76
	},
	"3/16:43": {
		"x": 496.96,
		"y": 323.48
	},
	"2/16:44": {
		"x": 451.54,
		"y": 349.4
	},
	"3/16:45-46": {
		"x": 482.75,
		"y": 304.14
	},
	"2/16:47": {
		"x": 499.24,
		"y": 344.12
	},
	"3/16:48": {
		"x": 437.33,
		"y": 330.06
	},
	"7/17:1-3": {
		"x": 613.85,
		"y": 320.33
	},
	"2/17:4": {
		"x": 601.48,
		"y": 340.24
	},
	"7/17:5": {
		"x": 580.52,
		"y": 329.76
	},
	"2/17:6": {
		"x": 613.12,
		"y": 343.19
	},
	"7/17:7": {
		"x": 589.85,
		"y": 337.3
	},
	"2/17:8": {
		"x": 609.85,
		"y": 331.64
	},
	"7/17:9": {
		"x": 604.75,
		"y": 351.79
	},
	"2/17:10": {
		"x": 581.49,
		"y": 345.9
	},
	"7/17:11-15": {
		"x": 622.03,
		"y": 334.42
	},
	"2/17:16-17": {
		"x": 593.12,
		"y": 348.84
	},
	"7/17:18-45": {
		"x": 595.85,
		"y": 320.33
	},
	"1/18:1-8": {
		"x": 738.12,
		"y": 336.32
	},
	"24/18:9": {
		"x": 700.94,
		"y": 341.44
	},
	"5/18:10-11": {
		"x": 741.49,
		"y": 323.25
	},
	"24/18:12": {
		"x": 746.14,
		"y": 362.64
	},
	"5/18:13-14": {
		"x": 714.83,
		"y": 306.05
	},
	"24/18:15": {
		"x": 761.96,
		"y": 334.84
	},
	"5/18:16": {
		"x": 707.77,
		"y": 351.29
	},
	"24/18:17": {
		"x": 738.59,
		"y": 302.67
	},
	"5/18:18": {
		"x": 753,
		"y": 342.81
	},
	"24/18:19": {
		"x": 712.17,
		"y": 337.23
	},
	"5/18:20": {
		"x": 755.06,
		"y": 319.96
	},
	"5/18:21-23": {
		"x": 730.97,
		"y": 347.77
	},
	"24/18:21-23": {
		"x": 726.71,
		"y": 304.36
	},
	"3/18:24": {
		"x": 764.37,
		"y": 346.6
	},
	"5/18:25-26": {
		"x": 719,
		"y": 347.07
	},
	"3/18:27": {
		"x": 745.98,
		"y": 312.12
	},
	"3/18:28": {
		"x": 734.55,
		"y": 359.56
	},
	"24/18:28": {
		"x": 710.36,
		"y": 317.18
	},
	"5/18:29-30": {
		"x": 766.45,
		"y": 323.72
	},
	"3/18:31": {
		"x": 722.6,
		"y": 358.52
	},
	"24/18:31": {
		"x": 722.23,
		"y": 315.49
	},
	"5/18:32-33": {
		"x": 755.06,
		"y": 354.63
	},
	"3/18:34": {
		"x": 717.77,
		"y": 326.62
	},
	"24/18:34": {
		"x": 757.3,
		"y": 308.17
	},
	"5/18:35-36": {
		"x": 724.62,
		"y": 336.48
	},
	"3/18:37": {
		"x": 734.11,
		"y": 313.8
	},
	"24/18:37": {
		"x": 750.56,
		"y": 331.08
	},
	"5/18:38": {
		"x": 711.37,
		"y": 362.74
	},
	"3/18:39": {
		"x": 729.73,
		"y": 325.62
	},
	"5/18:40-43": {
		"x": 743.16,
		"y": 350.51
	},
	"3/18:44-51": {
		"x": 702.31,
		"y": 328.01
	},
	"3/19:1-8": {
		"x": 82.36,
		"y": 465.53
	},
	"2/19:9": {
		"x": 59.64,
		"y": 469.32
	},
	"3/19:9": {
		"x": 65.82,
		"y": 449.42
	},
	"3/19:10-12": {
		"x": 81.44,
		"y": 479
	},
	"3/19:13": {
		"x": 48.2,
		"y": 465.71
	},
	"24/19:13": {
		"x": 77.27,
		"y": 453.03
	},
	"3/19:14-16": {
		"x": 62.23,
		"y": 481.04
	},
	"3/19:17-18": {
		"x": 57.05,
		"y": 457.61
	},
	"2/19:17-18": {
		"x": 71.08,
		"y": 472.94
	},
	"22/19:17-18": {
		"x": 50.79,
		"y": 477.42
	},
	"24/19:19": {
		"x": 68.5,
		"y": 461.22
	},
	"24/20:1": {
		"x": 236.09,
		"y": 495.98
	},
	"5/20:2": {
		"x": 223.58,
		"y": 462.27
	},
	"2/20:3": {
		"x": 221.18,
		"y": 438.61
	},
	"5/20:4": {
		"x": 221.02,
		"y": 450.6
	},
	"2/20:5-6": {
		"x": 180.31,
		"y": 460.9
	},
	"5/20:7": {
		"x": 174.92,
		"y": 480.93
	},
	"2/20:8": {
		"x": 186.45,
		"y": 484.21
	},
	"5/20:8": {
		"x": 199.3,
		"y": 441
	},
	"2/20:9": {
		"x": 203.52,
		"y": 511.64
	},
	"5/20:10-11": {
		"x": 164.74,
		"y": 443.15
	},
	"2/20:12": {
		"x": 239.64,
		"y": 474.95
	},
	"5/20:13": {
		"x": 180.74,
		"y": 504.2
	},
	"2/20:14": {
		"x": 209.73,
		"y": 435.09
	},
	"5/20:15": {
		"x": 214.95,
		"y": 470.57
	},
	"24/20:16-20": {
		"x": 156.18,
		"y": 467.35
	},
	"2/20:21": {
		"x": 200.59,
		"y": 455.41
	},
	"24/20:22": {
		"x": 191.99,
		"y": 508.34
	},
	"2/20:23-33": {
		"x": 188.01,
		"y": 449.24
	},
	"24/20:34": {
		"x": 251.47,
		"y": 476.85
	},
	"2/20:35": {
		"x": 166.31,
		"y": 489.26
	},
	"24/20:36": {
		"x": 179.62,
		"y": 427.41
	},
	"2/20:37-42": {
		"x": 223.09,
		"y": 496.3
	},
	"24/20:43": {
		"x": 191.95,
		"y": 463.75
	},
	"2/20:44-47": {
		"x": 247.29,
		"y": 465.08
	},
	"2/20:48": {
		"x": 197.97,
		"y": 487.52
	},
	"4/20:48": {
		"x": 199.38,
		"y": 429.02
	},
	"2/20:49-50": {
		"x": 231.72,
		"y": 484.81
	},
	"2/20:51": {
		"x": 156.54,
		"y": 496.22
	},
	"5/20:51": {
		"x": 209.8,
		"y": 423.09
	},
	"2/20:52-53": {
		"x": 212.14,
		"y": 503.3
	},
	"2/20:54": {
		"x": 177.77,
		"y": 439.26
	},
	"24/20:54": {
		"x": 232.92,
		"y": 449.26
	},
	"6/20:55-56": {
		"x": 189.36,
		"y": 495.86
	},
	"24/20:57": {
		"x": 190.05,
		"y": 421.48
	},
	"6/20:58-63": {
		"x": 218.86,
		"y": 482.95
	},
	"24/20:64-66": {
		"x": 153.45,
		"y": 484.63
	},
	"2/20:67": {
		"x": 233.1,
		"y": 437.26
	},
	"5/20:68": {
		"x": 200.61,
		"y": 500
	},
	"6/20:69": {
		"x": 188.96,
		"y": 434.95
	},
	"4/20:70": {
		"x": 227.74,
		"y": 473.48
	},
	"3/20:71": {
		"x": 174.09,
		"y": 450.67
	},
	"2/20:72-79": {
		"x": 223.12,
		"y": 425.26
	},
	"22/20:80": {
		"x": 194.95,
		"y": 475.75
	},
	"24/20:81-85": {
		"x": 155.57,
		"y": 451.64
	},
	"5/20:86": {
		"x": 235.49,
		"y": 460.98
	},
	"24/20:87": {
		"x": 169.21,
		"y": 500.9
	},
	"2/20:88-89": {
		"x": 209.53,
		"y": 447.21
	},
	"24/20:90": {
		"x": 243.62,
		"y": 486.27
	},
	"6/20:91": {
		"x": 171.84,
		"y": 469.35
	},
	"5/20:92": {
		"x": 212.06,
		"y": 458.94
	},
	"6/20:93": {
		"x": 209.23,
		"y": 491.66
	},
	"5/20:93": {
		"x": 168.43,
		"y": 431.74
	},
	"4/20:93": {
		"x": 203.42,
		"y": 467.27
	},
	"6/20:94": {
		"x": 177.83,
		"y": 492.56
	},
	"5/20:94": {
		"x": 183.42,
		"y": 472.47
	},
	"4/20:94": {
		"x": 206.47,
		"y": 479.05
	},
	"2/20:94": {
		"x": 165.57,
		"y": 459.12
	},
	"3/20:94": {
		"x": 244.36,
		"y": 452.9
	},
	"24/20:95": {
		"x": 163.21,
		"y": 477.68
	},
	"12/21:1-27": {
		"x": 333.21,
		"y": 466.46
	},
	"1/22:1-15": {
		"x": 468.3,
		"y": 464.2
	},
	"2/22:16-24": {
		"x": 452.04,
		"y": 467.01
	},
	"1/22:25": {
		"x": 467.73,
		"y": 449.21
	},
	"2/22:26-28": {
		"x": 474.48,
		"y": 477.87
	},
	"1/22:29": {
		"x": 456.92,
		"y": 454.42
	},
	"1/22:30-38": {
		"x": 484.22,
		"y": 468.52
	},
	"2/22:30-38": {
		"x": 461.03,
		"y": 479.01
	},
	"1/23:1": {
		"x": 579.74,
		"y": 502.44
	},
	"2/23:2": {
		"x": 632.95,
		"y": 486.02
	},
	"1/23:3": {
		"x": 571.59,
		"y": 429.1
	},
	"2/23:4": {
		"x": 606.23,
		"y": 453.09
	},
	"1/23:5-8": {
		"x": 610.84,
		"y": 507.93
	},
	"2/23:9-15": {
		"x": 568.3,
		"y": 496.32
	},
	"1/23:16-19": {
		"x": 618.79,
		"y": 475.04
	},
	"2/23:20-21": {
		"x": 580.16,
		"y": 437.42
	},
	"1/23:22-26": {
		"x": 611.24,
		"y": 408.07
	},
	"24/23:27": {
		"x": 642.65,
		"y": 432.92
	},
	"1/23:28-31": {
		"x": 585.91,
		"y": 413.51
	},
	"2/23:32-41": {
		"x": 656.64,
		"y": 456
	},
	"1/23:42": {
		"x": 622.53,
		"y": 525.44
	},
	"2/23:43": {
		"x": 636.53,
		"y": 463.53
	},
	"1/23:44": {
		"x": 655.96,
		"y": 492.71
	},
	"2/23:45": {
		"x": 557.17,
		"y": 489.64
	},
	"1/23:46-48": {
		"x": 618.61,
		"y": 432.42
	},
	"22/23:49": {
		"x": 545.91,
		"y": 444.18
	},
	"22/23:50": {
		"x": 569.47,
		"y": 442.81
	},
	"1/23:51-53": {
		"x": 610.01,
		"y": 495.5
	},
	"1/23:54-57": {
		"x": 611.33,
		"y": 464.44
	},
	"22/23:54-57": {
		"x": 595.41,
		"y": 422.35
	},
	"1/23:58-59": {
		"x": 599.15,
		"y": 489
	},
	"24/23:58-59": {
		"x": 554.71,
		"y": 477.92
	},
	"1/23:60": {
		"x": 654.19,
		"y": 480.84
	},
	"2/23:61": {
		"x": 545.38,
		"y": 467.15
	},
	"1/23:62": {
		"x": 557.82,
		"y": 445.62
	},
	"2/23:63": {
		"x": 591.73,
		"y": 434.28
	},
	"1/23:64": {
		"x": 567.19,
		"y": 483.07
	},
	"2/23:65": {
		"x": 579.14,
		"y": 475.97
	},
	"1/23:66": {
		"x": 635.46,
		"y": 497.71
	},
	"2/23:67": {
		"x": 583.23,
		"y": 425.84
	},
	"1/23:68": {
		"x": 636.55,
		"y": 443.24
	},
	"2/23:69-71": {
		"x": 578.91,
		"y": 517.09
	},
	"1/23:72": {
		"x": 630.59,
		"y": 432.86
	},
	"2/23:73": {
		"x": 644.79,
		"y": 513.09
	},
	"1/23:74": {
		"x": 542.75,
		"y": 478.84
	},
	"2/23:75": {
		"x": 624.2,
		"y": 443.01
	},
	"1/23:76": {
		"x": 633.35,
		"y": 509.51
	},
	"2/23:77-78": {
		"x": 588.38,
		"y": 494.17
	},
	"1/23:79": {
		"x": 622.02,
		"y": 513.45
	},
	"2/23:80": {
		"x": 558.97,
		"y": 514.24
	},
	"1/23:81": {
		"x": 613.14,
		"y": 420.41
	},
	"2/23:82": {
		"x": 611.65,
		"y": 520.39
	},
	"1/23:83": {
		"x": 557.32,
		"y": 466.22
	},
	"2/23:84": {
		"x": 642.9,
		"y": 453.41
	},
	"1/23:85": {
		"x": 588.77,
		"y": 510.29
	},
	"2/23:86-87": {
		"x": 574.03,
		"y": 417.38
	},
	"1/23:88": {
		"x": 647.99,
		"y": 467
	},
	"2/23:89": {
		"x": 588.64,
		"y": 445.86
	},
	"1/23:90": {
		"x": 623.52,
		"y": 410.36
	},
	"2/23:91-93": {
		"x": 589.77,
		"y": 522.25
	},
	"1/23:94": {
		"x": 548.74,
		"y": 432.53
	},
	"2/23:95-97": {
		"x": 621.06,
		"y": 487.39
	},
	"1/23:98": {
		"x": 630.2,
		"y": 453.4
	},
	"2/23:99": {
		"x": 600.2,
		"y": 442.82
	},
	"1/23:100": {
		"x": 642.63,
		"y": 477.72
	},
	"2/23:101-104": {
		"x": 600.64,
		"y": 474.98
	},
	"1/23:105-113": {
		"x": 638.31,
		"y": 420.15
	},
	"8/23:114-119": {
		"x": 566.11,
		"y": 456.63
	},
	"2/23:120": {
		"x": 561.91,
		"y": 422.03
	},
	"8/23:121": {
		"x": 589.68,
		"y": 481.69
	},
	"7/23:122-128": {
		"x": 598.75,
		"y": 501.96
	},
	"1/23:129-134": {
		"x": 605.72,
		"y": 431.05
	},
	"1/23:135-138": {
		"x": 600.2,
		"y": 515.38
	},
	"22/23:135-138": {
		"x": 537.64,
		"y": 457.34
	},
	"24/23:139-142": {
		"x": 649.92,
		"y": 443.08
	},
	"3/23:143-146": {
		"x": 556.09,
		"y": 502.08
	},
	"2/23:147": {
		"x": 576.25,
		"y": 405.59
	},
	"3/23:148": {
		"x": 646.92,
		"y": 501.29
	},
	"2/23:149": {
		"x": 577.29,
		"y": 463.26
	},
	"3/23:150": {
		"x": 624.98,
		"y": 422.27
	},
	"2/23:151": {
		"x": 631.16,
		"y": 474.21
	},
	"3/23:152": {
		"x": 618.19,
		"y": 453.41
	},
	"2/23:153": {
		"x": 644.38,
		"y": 489.57
	},
	"7/23:154": {
		"x": 568.24,
		"y": 471.13
	},
	"2/23:155": {
		"x": 624.19,
		"y": 463.8
	},
	"7/23:156": {
		"x": 587.98,
		"y": 457.8
	},
	"2/23:157": {
		"x": 589.33,
		"y": 469.73
	},
	"7/23:158": {
		"x": 612.21,
		"y": 442.69
	},
	"2/23:159": {
		"x": 578.16,
		"y": 487.9
	},
	"7/23:160": {
		"x": 598.98,
		"y": 462.61
	},
	"8/23:161-167": {
		"x": 622.05,
		"y": 500.35
	},
	"7/23:168-175": {
		"x": 543.93,
		"y": 492.29
	},
	"3/23:176-178": {
		"x": 560.65,
		"y": 433.98
	},
	"3/23:179-181": {
		"x": 602.15,
		"y": 527.72
	},
	"6/23:179-181": {
		"x": 577.95,
		"y": 451.27
	},
	"4/23:179-181": {
		"x": 659.57,
		"y": 470.12
	},
	"5/23:179-181": {
		"x": 569.87,
		"y": 509.21
	},
	"1/23:182-186": {
		"x": 598.35,
		"y": 409.71
	},
	"24/23:187": {
		"x": 609.75,
		"y": 483.5
	},
	"2/23:188-192": {
		"x": 550.55,
		"y": 455.76
	},
	"24/24:1-2": {
		"x": 752.46,
		"y": 446.05
	},
	"1/24:3-17": {
		"x": 733.53,
		"y": 482.06
	},
	"24/24:18-25": {
		"x": 717.43,
		"y": 447.81
	},
	"10/24:26-28": {
		"x": 750.4,
		"y": 458.46
	},
	"24/24:29": {
		"x": 707.34,
		"y": 482.59
	},
	"10/24:30-32": {
		"x": 741.05,
		"y": 449.77
	},
	"24/24:33": {
		"x": 741.53,
		"y": 494.75
	},
	"10/24:34-39": {
		"x": 716.91,
		"y": 462.29
	},
	"24/24:40": {
		"x": 761.51,
		"y": 453.93
	},
	"10/24:41-47": {
		"x": 718.35,
		"y": 490.18
	},
	"24/24:48-49": {
		"x": 728.23,
		"y": 455.9
	},
	"10/24:50-59": {
		"x": 747.56,
		"y": 472.47
	},
	"11/24:60-61": {
		"x": 728.64,
		"y": 467.89
	},
	"24/24:62": {
		"x": 740.66,
		"y": 437.78
	},
	"11/24:63-65": {
		"x": 750,
		"y": 486.25
	},
	"10/24:66": {
		"x": 706.08,
		"y": 455.11
	},
	"11/24:67": {
		"x": 759.88,
		"y": 465.81
	},
	"10/24:68-74": {
		"x": 718.65,
		"y": 476.19
	},
	"3/24:75": {
		"x": 730.47,
		"y": 444.12
	},
	"2/24:76": {
		"x": 759.78,
		"y": 479.3
	},
	"3/24:77": {
		"x": 706.91,
		"y": 470.6
	},
	"24/24:77": {
		"x": 738.82,
		"y": 461.54
	},
	"24/24:78-79": {
		"x": 729.68,
		"y": 496.56
	},
	"10/24:80": {
		"x": 722.39,
		"y": 435.25
	},
	"3/25:1-2": {
		"x": 60.64,
		"y": 592.54
	},
	"10/25:3-6": {
		"x": 42.41,
		"y": 608.82
	},
	"10/25:7": {
		"x": 79.47,
		"y": 577.68
	},
	"11/25:7": {
		"x": 87.38,
		"y": 625.43
	},
	"10/25:8-11": {
		"x": 37.78,
		"y": 583.75
	},
	"2/25:12": {
		"x": 70.05,
		"y": 585.1
	},
	"10/25:13-24": {
		"x": 58,
		"y": 626.54
	},
	"3/25:25-26": {
		"x": 57.18,
		"y": 568.79
	},
	"2/25:27-47": {
		"x": 82.15,
		"y": 609.79
	},
	"3/25:48-49": {
		"x": 30.9,
		"y": 603.96
	},
	"2/25:50": {
		"x": 81.19,
		"y": 589.55
	},
	"3/25:51": {
		"x": 80.33,
		"y": 635.12
	},
	"11/25:52": {
		"x": 49.49,
		"y": 588.12
	},
	"10/25:53": {
		"x": 90.61,
		"y": 582.15
	},
	"11/25:53": {
		"x": 45.58,
		"y": 633
	},
	"10/25:54": {
		"x": 68.32,
		"y": 573.24
	},
	"10/25:55": {
		"x": 62.39,
		"y": 604.4
	},
	"11/25:55": {
		"x": 54.14,
		"y": 613.09
	},
	"10/25:56": {
		"x": 102.58,
		"y": 582.99
	},
	"11/25:57": {
		"x": 66.7,
		"y": 615.59
	},
	"3/25:58": {
		"x": 47.76,
		"y": 576.23
	},
	"2/25:59": {
		"x": 98.17,
		"y": 605.86
	},
	"3/25:60": {
		"x": 39.92,
		"y": 596.06
	},
	"2/25:61": {
		"x": 88.91,
		"y": 570.28
	},
	"3/25:62": {
		"x": 74.72,
		"y": 624.52
	},
	"2/25:63": {
		"x": 51.25,
		"y": 599.99
	},
	"3/25:64": {
		"x": 91.27,
		"y": 596.04
	},
	"2/25:65": {
		"x": 45.14,
		"y": 621.02
	},
	"3/25:66": {
		"x": 66.6,
		"y": 561.37
	},
	"2/25:67": {
		"x": 96.6,
		"y": 617.75
	},
	"3/25:68": {
		"x": 28.57,
		"y": 592.19
	},
	"2/25:69": {
		"x": 71.78,
		"y": 596.96
	},
	"3/25:70": {
		"x": 68.36,
		"y": 635.95
	},
	"2/25:71": {
		"x": 58.91,
		"y": 580.67
	},
	"3/25:72": {
		"x": 103.22,
		"y": 594.97
	},
	"2/25:73": {
		"x": 33.61,
		"y": 617.69
	},
	"3/25:74": {
		"x": 77.75,
		"y": 565.81
	},
	"7/26:1-6": {
		"x": 201.88,
		"y": 619.22
	},
	"15/26:7-12": {
		"x": 174.29,
		"y": 591.57
	},
	"7/26:13": {
		"x": 187.11,
		"y": 589.56
	},
	"15/26:13": {
		"x": 185.9,
		"y": 633.03
	},
	"2/26:14-22": {
		"x": 188.17,
		"y": 564.8
	},
	"2/26:23-27": {
		"x": 237.95,
		"y": 600.12
	},
	"8/26:23-27": {
		"x": 156.91,
		"y": 618.79
	},
	"7/26:28": {
		"x": 224.67,
		"y": 564.22
	},
	"2/26:29": {
		"x": 194.59,
		"y": 643.1
	},
	"7/26:30-31": {
		"x": 183.77,
		"y": 601.08
	},
	"2/26:32": {
		"x": 207.69,
		"y": 595.01
	},
	"7/26:33": {
		"x": 174.29,
		"y": 636.04
	},
	"2/26:34": {
		"x": 195.38,
		"y": 598.23
	},
	"7/26:35-38": {
		"x": 223.7,
		"y": 624.22
	},
	"15/26:39-49": {
		"x": 159.36,
		"y": 592.88
	},
	"7/26:50": {
		"x": 233.68,
		"y": 588.34
	},
	"2/26:51": {
		"x": 219.43,
		"y": 636.87
	},
	"7/26:52-53": {
		"x": 210.26,
		"y": 583.3
	},
	"2/26:54": {
		"x": 215.76,
		"y": 603.89
	},
	"7/26:55-56": {
		"x": 160.52,
		"y": 606.84
	},
	"2/26:57": {
		"x": 220.91,
		"y": 552.83
	},
	"7/26:58": {
		"x": 207.32,
		"y": 638.86
	},
	"2/26:59": {
		"x": 166.74,
		"y": 580.99
	},
	"7/26:60": {
		"x": 240.21,
		"y": 578.29
	},
	"2/26:61": {
		"x": 192.57,
		"y": 609.9
	},
	"8/26:62-73": {
		"x": 202.82,
		"y": 571.45
	},
	"2/26:74": {
		"x": 236.16,
		"y": 623.36
	},
	"8/26:74": {
		"x": 211.7,
		"y": 627.69
	},
	"8/26:75": {
		"x": 228.4,
		"y": 575.89
	},
	"2/26:76": {
		"x": 169.07,
		"y": 615.94
	},
	"8/26:76": {
		"x": 172.26,
		"y": 604.38
	},
	"8/26:77-84": {
		"x": 227.38,
		"y": 610.73
	},
	"2/26:85-86": {
		"x": 225.79,
		"y": 597.34
	},
	"8/26:85-86": {
		"x": 212.93,
		"y": 561.77
	},
	"7/26:87": {
		"x": 231.14,
		"y": 634.26
	},
	"7/26:88": {
		"x": 154.83,
		"y": 579.64
	},
	"8/26:89": {
		"x": 236.36,
		"y": 566.92
	},
	"2/26:90": {
		"x": 182.69,
		"y": 644.59
	},
	"8/26:91": {
		"x": 190,
		"y": 551.43
	},
	"2/26:92": {
		"x": 240.79,
		"y": 612.29
	},
	"8/26:93": {
		"x": 204.07,
		"y": 606.47
	},
	"7/26:94": {
		"x": 216.71,
		"y": 573.19
	},
	"2/26:95": {
		"x": 189.1,
		"y": 621.47
	},
	"8/26:96": {
		"x": 190.52,
		"y": 578.08
	},
	"2/26:97": {
		"x": 245.53,
		"y": 590.19
	},
	"8/26:98": {
		"x": 177.49,
		"y": 624.48
	},
	"7/26:99": {
		"x": 200.24,
		"y": 557.69
	},
	"8/26:100": {
		"x": 214.42,
		"y": 615.81
	},
	"7/26:101": {
		"x": 149.3,
		"y": 602.61
	},
	"8/26:101": {
		"x": 180.88,
		"y": 612.72
	},
	"2/26:102": {
		"x": 197.81,
		"y": 631.54
	},
	"7/26:103-104": {
		"x": 178.6,
		"y": 579.32
	},
	"8/26:103-104": {
		"x": 249.73,
		"y": 604.29
	},
	"2/26:105": {
		"x": 165.87,
		"y": 627.5
	},
	"7/26:106": {
		"x": 198.79,
		"y": 586.76
	},
	"8/26:106": {
		"x": 204.1,
		"y": 650.41
	},
	"7/26:107-117": {
		"x": 172.77,
		"y": 566.59
	},
	"2/26:118-119": {
		"x": 221.92,
		"y": 585.98
	},
	"1/27:1-4": {
		"x": 318.31,
		"y": 638.67
	},
	"2/27:5-11": {
		"x": 328.33,
		"y": 568.91
	},
	"16/27:12-14": {
		"x": 364.47,
		"y": 599
	},
	"2/27:15": {
		"x": 315.65,
		"y": 571.76
	},
	"16/27:16-19": {
		"x": 363.02,
		"y": 574.15
	},
	"2/27:20": {
		"x": 316.41,
		"y": 590.67
	},
	"16/27:21": {
		"x": 306.17,
		"y": 564.41
	},
	"2/27:22-23": {
		"x": 364.59,
		"y": 610.99
	},
	"16/27:24": {
		"x": 310.05,
		"y": 629.29
	},
	"2/27:25-27": {
		"x": 352.67,
		"y": 567.16
	},
	"16/27:28": {
		"x": 359.53,
		"y": 622.31
	},
	"2/27:29": {
		"x": 296.62,
		"y": 597.75
	},
	"16/27:30": {
		"x": 341.63,
		"y": 591.39
	},
	"2/27:31-37": {
		"x": 321.05,
		"y": 602.79
	},
	"16/27:38": {
		"x": 327.97,
		"y": 613.85
	},
	"2/27:39": {
		"x": 340.74,
		"y": 613.4
	},
	"2/27:40": {
		"x": 290.2,
		"y": 614.09
	},
	"24/27:40": {
		"x": 341.19,
		"y": 570.66
	},
	"2/27:41": {
		"x": 343.39,
		"y": 634.54
	},
	"2/27:42": {
		"x": 292.82,
		"y": 586.38
	},
	"24/27:42": {
		"x": 374.29,
		"y": 592.04
	},
	"2/27:43": {
		"x": 323.04,
		"y": 625.93
	},
	"2/27:44": {
		"x": 335.38,
		"y": 581.16
	},
	"24/27:44": {
		"x": 371.43,
		"y": 620.85
	},
	"2/27:45": {
		"x": 301.12,
		"y": 609.13
	},
	"24/27:46-53": {
		"x": 350.45,
		"y": 580.47
	},
	"2/27:54-57": {
		"x": 330.95,
		"y": 635.7
	},
	"17/27:58-61": {
		"x": 329.14,
		"y": 591.99
	},
	"2/27:62": {
		"x": 345.94,
		"y": 602.58
	},
	"17/27:63-66": {
		"x": 300.21,
		"y": 621.59
	},
	"2/27:67-69": {
		"x": 343.89,
		"y": 558.98
	},
	"16/27:70": {
		"x": 347.52,
		"y": 623.28
	},
	"2/27:71": {
		"x": 304.66,
		"y": 588.28
	},
	"16/27:72": {
		"x": 363.59,
		"y": 586.63
	},
	"2/27:73": {
		"x": 334.86,
		"y": 623.83
	},
	"16/27:74": {
		"x": 318.71,
		"y": 560.17
	},
	"2/27:75": {
		"x": 352.71,
		"y": 612.46
	},
	"16/27:76": {
		"x": 323.38,
		"y": 580.91
	},
	"2/27:77": {
		"x": 334,
		"y": 603.49
	},
	"16/27:78-80": {
		"x": 338.64,
		"y": 645.55
	},
	"2/27:81-83": {
		"x": 304.54,
		"y": 576.29
	},
	"16/27:84-90": {
		"x": 376.07,
		"y": 604.91
	},
	"2/27:91-101": {
		"x": 313.47,
		"y": 615.72
	},
	"24/27:102": {
		"x": 332.16,
		"y": 556.5
	},
	"2/27:103-105": {
		"x": 355.35,
		"y": 633.55
	},
	"17/27:106": {
		"x": 308.47,
		"y": 599.65
	},
	"2/27:107": {
		"x": 353.79,
		"y": 593.55
	},
	"1/28:1": {
		"x": 467.67,
		"y": 554.79
	},
	"2/28:2": {
		"x": 426.4,
		"y": 604.03
	},
	"1/28:3": {
		"x": 504.21,
		"y": 618.4
	},
	"2/28:4": {
		"x": 458.1,
		"y": 547.58
	},
	"1/28:5": {
		"x": 515.59,
		"y": 564.6
	},
	"2/28:6": {
		"x": 492.7,
		"y": 654.02
	},
	"1/28:7": {
		"x": 455.12,
		"y": 617.4
	},
	"2/28:8": {
		"x": 517.42,
		"y": 576.45
	},
	"1/28:9": {
		"x": 436.36,
		"y": 626.81
	},
	"2/28:10": {
		"x": 446.5,
		"y": 544.49
	},
	"1/28:11": {
		"x": 500.42,
		"y": 639.27
	},
	"2/28:12": {
		"x": 438.29,
		"y": 605.7
	},
	"1/28:13": {
		"x": 421.94,
		"y": 592.91
	},
	"2/28:14": {
		"x": 520.01,
		"y": 632.64
	},
	"1/28:15": {
		"x": 429.39,
		"y": 636.54
	},
	"2/28:16": {
		"x": 504.87,
		"y": 606.16
	},
	"1/28:17": {
		"x": 441.22,
		"y": 564.6
	},
	"2/28:18": {
		"x": 449.63,
		"y": 556.05
	},
	"1/28:19": {
		"x": 485.02,
		"y": 631.23
	},
	"2/28:20": {
		"x": 410,
		"y": 591.6
	},
	"11/28:21": {
		"x": 520.62,
		"y": 588
	},
	"2/28:22": {
		"x": 449.03,
		"y": 660.32
	},
	"1/28:23": {
		"x": 494.3,
		"y": 570.42
	},
	"2/28:24": {
		"x": 465.21,
		"y": 639.39
	},
	"1/28:25": {
		"x": 444.08,
		"y": 649.39
	},
	"1/28:26": {
		"x": 499.43,
		"y": 550
	},
	"24/28:26": {
		"x": 459.19,
		"y": 563.24
	},
	"1/28:27": {
		"x": 412.05,
		"y": 571.04
	},
	"1/28:28": {
		"x": 457.34,
		"y": 596.72
	},
	"24/28:28": {
		"x": 480.97,
		"y": 651.64
	},
	"1/28:29-46": {
		"x": 437.52,
		"y": 579.63
	},
	"1/28:47": {
		"x": 488.91,
		"y": 642.6
	},
	"24/28:47": {
		"x": 441.31,
		"y": 637.71
	},
	"10/28:48-49": {
		"x": 505.7,
		"y": 574.12
	},
	"1/28:50": {
		"x": 462.2,
		"y": 661.46
	},
	"24/28:50": {
		"x": 460.24,
		"y": 628.53
	},
	"10/28:51": {
		"x": 516.04,
		"y": 620.4
	},
	"2/28:52": {
		"x": 462.31,
		"y": 574.96
	},
	"10/28:53": {
		"x": 475.71,
		"y": 545.89
	},
	"1/28:54": {
		"x": 474.2,
		"y": 661.55
	},
	"24/28:54": {
		"x": 438.05,
		"y": 553.04
	},
	"10/28:55-56": {
		"x": 500.96,
		"y": 594.82
	},
	"1/28:57": {
		"x": 437.09,
		"y": 659.14
	},
	"24/28:57": {
		"x": 434.89,
		"y": 541.47
	},
	"10/28:58-59": {
		"x": 469.01,
		"y": 650.74
	},
	"1/28:60-61": {
		"x": 405.35,
		"y": 614.51
	},
	"1/28:62-64": {
		"x": 479.38,
		"y": 557.25
	},
	"24/28:62-64": {
		"x": 512.71,
		"y": 597.08
	},
	"1/28:65": {
		"x": 470.72,
		"y": 566.42
	},
	"1/28:66-68": {
		"x": 497.32,
		"y": 582.67
	},
	"24/28:66-68": {
		"x": 433.8,
		"y": 594.66
	},
	"1/28:69-75": {
		"x": 479.37,
		"y": 533.43
	},
	"1/28:76": {
		"x": 504.19,
		"y": 650.65
	},
	"24/28:76": {
		"x": 473.84,
		"y": 577.99
	},
	"1/28:77": {
		"x": 470.02,
		"y": 598.65
	},
	"24/28:78": {
		"x": 450.8,
		"y": 571.75
	},
	"1/28:79-82": {
		"x": 417.84,
		"y": 614.73
	},
	"11/28:83": {
		"x": 477.15,
		"y": 640.26
	},
	"10/28:84": {
		"x": 411.72,
		"y": 625.61
	},
	"11/28:85": {
		"x": 491.28,
		"y": 558.81
	},
	"10/28:86": {
		"x": 453.15,
		"y": 584.13
	},
	"11/28:87": {
		"x": 423.97,
		"y": 572.13
	},
	"10/28:88": {
		"x": 524.49,
		"y": 599.34
	},
	"11/28:89": {
		"x": 453.3,
		"y": 638.29
	},
	"10/28:90": {
		"x": 466.13,
		"y": 538.68
	},
	"11/28:91": {
		"x": 496.54,
		"y": 627.93
	},
	"10/28:92": {
		"x": 443.22,
		"y": 616.58
	},
	"1/28:93": {
		"x": 482.45,
		"y": 568.83
	},
	"24/28:94-95": {
		"x": 417.09,
		"y": 581.94
	},
	"1/28:96-101": {
		"x": 416.91,
		"y": 558.99
	},
	"24/28:96-101": {
		"x": 533.46,
		"y": 589.95
	},
	"1/28:102": {
		"x": 432.14,
		"y": 648.21
	},
	"1/28:103-105": {
		"x": 489.42,
		"y": 591.68
	},
	"24/28:103-105": {
		"x": 512.16,
		"y": 641.68
	},
	"1/28:106": {
		"x": 404.98,
		"y": 580.72
	},
	"24/28:107": {
		"x": 508.88,
		"y": 585.74
	},
	"1/28:108": {
		"x": 462.17,
		"y": 607.7
	},
	"24/28:109": {
		"x": 426.42,
		"y": 550.02
	},
	"1/28:110-111": {
		"x": 527.7,
		"y": 623.47
	},
	"24/28:112": {
		"x": 423.71,
		"y": 625.98
	},
	"1/28:113-114": {
		"x": 485.6,
		"y": 580.35
	},
	"2/28:115-116": {
		"x": 516.64,
		"y": 608.42
	},
	"1/28:117": {
		"x": 429.65,
		"y": 561.58
	},
	"2/28:118-122": {
		"x": 528.87,
		"y": 611.03
	},
	"2/28:123": {
		"x": 445.76,
		"y": 593.58
	},
	"24/28:123": {
		"x": 450.25,
		"y": 606.41
	},
	"2/28:124-126": {
		"x": 473.26,
		"y": 628.91
	},
	"2/28:127-130": {
		"x": 430.77,
		"y": 615.67
	},
	"10/28:127-130": {
		"x": 503.41,
		"y": 561.85
	},
	"11/28:127-130": {
		"x": 456.52,
		"y": 650.33
	},
	"3/28:127-130": {
		"x": 465.3,
		"y": 587.09
	},
	"1/28:131-167": {
		"x": 485.55,
		"y": 611.25
	},
	"24/28:168": {
		"x": 448.31,
		"y": 627.43
	},
	"1/28:169": {
		"x": 487.73,
		"y": 547.35
	},
	"24/28:170": {
		"x": 466.98,
		"y": 618.68
	},
	"1/28:171": {
		"x": 414.52,
		"y": 602.7
	},
	"24/28:172": {
		"x": 529.35,
		"y": 577.62
	},
	"1/28:173": {
		"x": 417.4,
		"y": 636.18
	},
	"1/28:174": {
		"x": 477.62,
		"y": 589.39
	},
	"24/28:174": {
		"x": 508.4,
		"y": 629.64
	},
	"1/28:175-182": {
		"x": 401.06,
		"y": 601.71
	},
	"15/29:1-4": {
		"x": 613.92,
		"y": 582.54
	},
	"7/29:5": {
		"x": 600.23,
		"y": 612.16
	},
	"15/29:6": {
		"x": 583.48,
		"y": 574.12
	},
	"7/29:7": {
		"x": 633.17,
		"y": 597.67
	},
	"15/29:8": {
		"x": 578.27,
		"y": 621.83
	},
	"15/29:9": {
		"x": 603.66,
		"y": 575.42
	},
	"7/29:9": {
		"x": 601.53,
		"y": 600.23
	},
	"15/29:10": {
		"x": 580.88,
		"y": 597.97
	},
	"7/29:11": {
		"x": 623.5,
		"y": 590.57
	},
	"15/29:12": {
		"x": 589.25,
		"y": 616.99
	},
	"7/29:12": {
		"x": 591.85,
		"y": 593.14
	},
	"2/29:13-14": {
		"x": 620.89,
		"y": 614.42
	},
	"1/29:15": {
		"x": 569.9,
		"y": 602.81
	},
	"2/29:16": {
		"x": 602.83,
		"y": 588.3
	},
	"1/29:17-18": {
		"x": 609.9,
		"y": 619.25
	},
	"2/29:19": {
		"x": 582.18,
		"y": 586.05
	},
	"1/29:20-22": {
		"x": 622.19,
		"y": 602.49
	},
	"2/29:23": {
		"x": 590.56,
		"y": 605.07
	},
	"1/29:24-25": {
		"x": 593.16,
		"y": 581.21
	},
	"2/29:26": {
		"x": 611.2,
		"y": 607.32
	},
	"1/29:27": {
		"x": 579.57,
		"y": 609.9
	},
	"2/29:28": {
		"x": 612.51,
		"y": 595.39
	},
	"1/29:29-31": {
		"x": 598.92,
		"y": 624.09
	},
	"3/30:1": {
		"x": 721.12,
		"y": 586.93
	},
	"10/30:2-5": {
		"x": 745.42,
		"y": 591.35
	},
	"11/30:6": {
		"x": 729.08,
		"y": 609.56
	},
	"10/30:7-18": {
		"x": 736.9,
		"y": 566.32
	},
	"24/30:19": {
		"x": 741.02,
		"y": 631
	},
	"10/30:20": {
		"x": 725.05,
		"y": 598.26
	},
	"3/30:21": {
		"x": 766.12,
		"y": 586.2
	},
	"2/30:22-29": {
		"x": 720.93,
		"y": 620.31
	},
	"3/30:30": {
		"x": 728.87,
		"y": 577.79
	},
	"10/30:31": {
		"x": 751.84,
		"y": 605.11
	},
	"3/30:32": {
		"x": 705.43,
		"y": 605.08
	},
	"10/30:33": {
		"x": 749.74,
		"y": 571.9
	},
	"3/30:34": {
		"x": 734.41,
		"y": 620.99
	},
	"10/30:35": {
		"x": 709.33,
		"y": 584.67
	},
	"3/30:36-38": {
		"x": 764.1,
		"y": 604.55
	},
	"2/30:39": {
		"x": 707.9,
		"y": 616.82
	},
	"3/30:40": {
		"x": 736.85,
		"y": 600.41
	},
	"10/30:41": {
		"x": 748.24,
		"y": 621.43
	},
	"2/30:42": {
		"x": 701.49,
		"y": 593.75
	},
	"10/30:43-45": {
		"x": 754.59,
		"y": 582.87
	},
	"2/30:46-49": {
		"x": 728.57,
		"y": 632.04
	},
	"10/30:50": {
		"x": 732.92,
		"y": 589.08
	},
	"2/30:51": {
		"x": 758.45,
		"y": 615.13
	},
	"10/30:52": {
		"x": 717.22,
		"y": 607.34
	},
	"2/30:53": {
		"x": 740.7,
		"y": 579.8
	},
	"10/30:54": {
		"x": 741.63,
		"y": 611.41
	},
	"2/30:55": {
		"x": 713.28,
		"y": 596.01
	},
	"10/30:56": {
		"x": 757.5,
		"y": 594.53
	},
	"3/30:57": {
		"x": 710.27,
		"y": 628.58
	},
	"10/30:58": {
		"x": 717.1,
		"y": 575.53
	},
	"1/31:1-2": {
		"x": 100.47,
		"y": 744.52
	},
	"10/31:3-14": {
		"x": 44.35,
		"y": 729.83
	},
	"10/31:15-17": {
		"x": 72.05,
		"y": 723.56
	},
	"1/31:15-17": {
		"x": 69.18,
		"y": 775.63
	},
	"11/31:18": {
		"x": 56.09,
		"y": 754.62
	},
	"10/31:19-20": {
		"x": 96.01,
		"y": 722.9
	},
	"11/31:19-20": {
		"x": 55.55,
		"y": 738.18
	},
	"1/31:19-20": {
		"x": 68.32,
		"y": 704.79
	},
	"11/31:21-22": {
		"x": 76.53,
		"y": 745.56
	},
	"1/31:23": {
		"x": 26.86,
		"y": 717.62
	},
	"10/31:24": {
		"x": 89.25,
		"y": 712.15
	},
	"11/31:25": {
		"x": 63.04,
		"y": 765.32
	},
	"10/31:26-27": {
		"x": 56.35,
		"y": 705.68
	},
	"11/31:28": {
		"x": 78.89,
		"y": 733.8
	},
	"10/31:29": {
		"x": 24.42,
		"y": 742.4
	},
	"11/31:30": {
		"x": 63.1,
		"y": 715.6
	},
	"1/31:31": {
		"x": 88.96,
		"y": 767.68
	},
	"10/31:32": {
		"x": 44.38,
		"y": 706.35
	},
	"11/31:33": {
		"x": 108.06,
		"y": 721.97
	},
	"10/31:33": {
		"x": 42.07,
		"y": 757.54
	},
	"10/31:34-38": {
		"x": 73.92,
		"y": 693.06
	},
	"11/31:39-45": {
		"x": 95.86,
		"y": 756.66
	},
	"1/31:39-45": {
		"x": 29.37,
		"y": 730.38
	},
	"10/31:39-45": {
		"x": 95.49,
		"y": 700.45
	},
	"10/31:46": {
		"x": 70.89,
		"y": 756.27
	},
	"11/31:46": {
		"x": 57.93,
		"y": 726.43
	},
	"10/31:47": {
		"x": 102.84,
		"y": 732.77
	},
	"11/31:47": {
		"x": 36.37,
		"y": 741.32
	},
	"1/31:47": {
		"x": 77.26,
		"y": 712.79
	},
	"24/31:48": {
		"x": 82.88,
		"y": 756.09
	},
	"10/31:49": {
		"x": 51.13,
		"y": 716.55
	},
	"11/31:49": {
		"x": 101.24,
		"y": 712.11
	},
	"1/31:49": {
		"x": 51.05,
		"y": 765.49
	},
	"24/31:50": {
		"x": 61.56,
		"y": 694.88
	},
	"10/31:51": {
		"x": 88.52,
		"y": 745.5
	},
	"11/31:51": {
		"x": 47.11,
		"y": 746.66
	},
	"1/31:51": {
		"x": 66.92,
		"y": 734.36
	},
	"24/31:52": {
		"x": 77.02,
		"y": 766.56
	},
	"10/31:53-55": {
		"x": 32.39,
		"y": 706.87
	},
	"11/31:53-55": {
		"x": 90.88,
		"y": 733.74
	},
	"1/31:53-55": {
		"x": 39.67,
		"y": 769.29
	},
	"11/31:56": {
		"x": 82.6,
		"y": 702.04
	},
	"10/31:57": {
		"x": 64.53,
		"y": 746.12
	},
	"11/31:57": {
		"x": 38.84,
		"y": 716.99
	},
	"1/31:57": {
		"x": 84.02,
		"y": 722.95
	},
	"10/31:58": {
		"x": 57.19,
		"y": 775.8
	},
	"10/31:59-60": {
		"x": 49.58,
		"y": 695.54
	},
	"11/31:59-60": {
		"x": 111.84,
		"y": 740.69
	},
	"1/31:59-60": {
		"x": 31.32,
		"y": 752.21
	},
	"2/32:1": {
		"x": 210.4,
		"y": 719.28
	},
	"3/32:2": {
		"x": 206.27,
		"y": 742.86
	},
	"2/32:3": {
		"x": 177.76,
		"y": 718.97
	},
	"3/32:4": {
		"x": 241.04,
		"y": 732.67
	},
	"2/32:5": {
		"x": 194.77,
		"y": 746.27
	},
	"3/32:6": {
		"x": 203.64,
		"y": 709.39
	},
	"2/32:7": {
		"x": 223.94,
		"y": 760.48
	},
	"3/32:8": {
		"x": 183.28,
		"y": 749.68
	},
	"2/32:9": {
		"x": 215.59,
		"y": 708.48
	},
	"3/32:10": {
		"x": 200.67,
		"y": 766.2
	},
	"2/32:11-12": {
		"x": 176.11,
		"y": 707.09
	},
	"3/32:13": {
		"x": 217.77,
		"y": 739.47
	},
	"2/32:14": {
		"x": 173.65,
		"y": 742.55
	},
	"3/32:15": {
		"x": 197.56,
		"y": 734.61
	},
	"2/32:16": {
		"x": 186.06,
		"y": 738.02
	},
	"3/32:17": {
		"x": 187.41,
		"y": 726.09
	},
	"2/32:18": {
		"x": 234.63,
		"y": 722.53
	},
	"3/32:19-25": {
		"x": 188.39,
		"y": 770.43
	},
	"2/32:26": {
		"x": 184.89,
		"y": 698.91
	},
	"3/32:27": {
		"x": 226.74,
		"y": 748.82
	},
	"2/32:28": {
		"x": 167.77,
		"y": 753
	},
	"3/32:29": {
		"x": 225.27,
		"y": 701.39
	},
	"2/32:30": {
		"x": 203.47,
		"y": 754.53
	},
	"3/32:31-33": {
		"x": 198.92,
		"y": 722.68
	},
	"2/32:34-35": {
		"x": 209.07,
		"y": 731.2
	},
	"3/32:36-41": {
		"x": 177.68,
		"y": 761.41
	},
	"2/32:42": {
		"x": 196.87,
		"y": 699.49
	},
	"3/32:43": {
		"x": 214.97,
		"y": 751.12
	},
	"2/32:44": {
		"x": 176.41,
		"y": 730.87
	},
	"3/32:45": {
		"x": 226.31,
		"y": 713.87
	},
	"2/32:46": {
		"x": 191.97,
		"y": 757.93
	},
	"3/32:47-56": {
		"x": 189.89,
		"y": 711.99
	},
	"2/32:57": {
		"x": 229.97,
		"y": 737.27
	},
	"2/32:58-62": {
		"x": 163.95,
		"y": 734.66
	},
	"3/32:63": {
		"x": 208.83,
		"y": 698.57
	},
	"21/32:64": {
		"x": 212.17,
		"y": 762.79
	},
	"2/32:65": {
		"x": 166.27,
		"y": 722.37
	},
	"3/32:66-74": {
		"x": 221.74,
		"y": 726.57
	},
	"12/33:1-26": {
		"x": 333.2,
		"y": 733.21
	},
	"1/34:1-5": {
		"x": 458.07,
		"y": 713.25
	},
	"1/34:6": {
		"x": 472.01,
		"y": 742.39
	},
	"24/34:6": {
		"x": 461.03,
		"y": 737.56
	},
	"1/34:7": {
		"x": 470.71,
		"y": 730.47
	},
	"10/34:8": {
		"x": 462.34,
		"y": 749.49
	},
	"1/34:9-10": {
		"x": 459.72,
		"y": 725.63
	},
	"10/34:11": {
		"x": 481.69,
		"y": 735.29
	},
	"1/34:12": {
		"x": 451.36,
		"y": 744.66
	},
	"2/34:13": {
		"x": 469.4,
		"y": 718.54
	},
	"1/34:14": {
		"x": 483,
		"y": 747.22
	},
	"11/34:15": {
		"x": 450.05,
		"y": 732.73
	},
	"10/34:16": {
		"x": 480.38,
		"y": 723.37
	},
	"2/35:1-4": {
		"x": 603.03,
		"y": 745.58
	},
	"10/35:5": {
		"x": 608.47,
		"y": 713.59
	},
	"11/35:6": {
		"x": 597.04,
		"y": 734.65
	},
	"1/35:7": {
		"x": 575.35,
		"y": 742.78
	},
	"2/35:8": {
		"x": 608.4,
		"y": 692.8
	},
	"11/35:9": {
		"x": 604.53,
		"y": 766.84
	},
	"10/35:10": {
		"x": 602.82,
		"y": 724.16
	},
	"11/35:11": {
		"x": 621.13,
		"y": 734.31
	},
	"10/35:12": {
		"x": 585.8,
		"y": 757.51
	},
	"1/35:13": {
		"x": 590.48,
		"y": 702.52
	},
	"10/35:14": {
		"x": 621.77,
		"y": 755.11
	},
	"11/35:14": {
		"x": 585.12,
		"y": 735.84
	},
	"1/35:15": {
		"x": 614.8,
		"y": 724.11
	},
	"1/35:16": {
		"x": 592.31,
		"y": 767.59
	},
	"10/35:16": {
		"x": 583.39,
		"y": 712.79
	},
	"11/35:16": {
		"x": 633.12,
		"y": 733.93
	},
	"2/35:17": {
		"x": 574.13,
		"y": 754.71
	},
	"10/35:18": {
		"x": 602.45,
		"y": 703.21
	},
	"11/35:18": {
		"x": 616.61,
		"y": 765.95
	},
	"1/35:18": {
		"x": 561.04,
		"y": 724.59
	},
	"2/35:19-20": {
		"x": 638.79,
		"y": 723.35
	},
	"10/35:21": {
		"x": 577.55,
		"y": 766.21
	},
	"11/35:21": {
		"x": 590.04,
		"y": 724.89
	},
	"1/35:21": {
		"x": 633.76,
		"y": 754.72
	},
	"2/35:22-23": {
		"x": 565.71,
		"y": 735.64
	},
	"1/35:24": {
		"x": 620.47,
		"y": 713.54
	},
	"2/35:25": {
		"x": 609.81,
		"y": 756.06
	},
	"10/35:26": {
		"x": 571.01,
		"y": 711.2
	},
	"11/35:26": {
		"x": 626.79,
		"y": 723.73
	},
	"1/35:26": {
		"x": 590.57,
		"y": 746.51
	},
	"1/35:27-30": {
		"x": 595.84,
		"y": 713.82
	},
	"10/35:31": {
		"x": 615.48,
		"y": 744.89
	},
	"2/35:32-45": {
		"x": 575.53,
		"y": 724.98
	},
	"10/35:46": {
		"x": 632.46,
		"y": 713.16
	},
	"11/35:47": {
		"x": 597.78,
		"y": 756.91
	},
	"2/35:48": {
		"x": 578.5,
		"y": 701.84
	},
	"10/35:49": {
		"x": 627.48,
		"y": 744.51
	},
	"11/35:49": {
		"x": 564.38,
		"y": 747.62
	},
	"2/35:50-52": {
		"x": 614.45,
		"y": 703.16
	},
	"1/35:53": {
		"x": 609.03,
		"y": 734.62
	},
	"2/36:1-34": {
		"x": 725.32,
		"y": 729.73
	},
	"1/36:35": {
		"x": 754.04,
		"y": 733.59
	},
	"24/36:36-37": {
		"x": 732.12,
		"y": 747.46
	},
	"1/36:36-37": {
		"x": 738.64,
		"y": 716.18
	},
	"2/36:38-43": {
		"x": 742.61,
		"y": 739.78
	},
	"24/36:44": {
		"x": 720.14,
		"y": 748
	},
	"2/36:45": {
		"x": 744.1,
		"y": 726.87
	},
	"24/37:1": {
		"x": 93.54,
		"y": 847.75
	},
	"10/37:2": {
		"x": 78.14,
		"y": 876.32
	},
	"11/37:2": {
		"x": 100.94,
		"y": 868.85
	},
	"8/37:2": {
		"x": 33.98,
		"y": 880.23
	},
	"1/37:3-4": {
		"x": 74.99,
		"y": 832.55
	},
	"10/37:3-4": {
		"x": 93.53,
		"y": 904.07
	},
	"11/37:3-4": {
		"x": 27.33,
		"y": 860.56
	},
	"11/37:5": {
		"x": 52.48,
		"y": 840.82
	},
	"2/37:6-9": {
		"x": 52.97,
		"y": 897.21
	},
	"10/37:6-9": {
		"x": 68.5,
		"y": 868.42
	},
	"11/37:10": {
		"x": 98.46,
		"y": 880.58
	},
	"1/37:10": {
		"x": 54.86,
		"y": 884.42
	},
	"10/37:10": {
		"x": 80.13,
		"y": 863.99
	},
	"2/37:11": {
		"x": 64.54,
		"y": 892.53
	},
	"10/37:11": {
		"x": 31.67,
		"y": 835.5
	},
	"11/37:11": {
		"x": 103.97,
		"y": 856.52
	},
	"1/37:12": {
		"x": 71.02,
		"y": 856.2
	},
	"11/37:13": {
		"x": 58.96,
		"y": 860.42
	},
	"22/37:14": {
		"x": 96,
		"y": 892.33
	},
	"2/37:15": {
		"x": 38.69,
		"y": 856.72
	},
	"10/37:15": {
		"x": 61.63,
		"y": 848.72
	},
	"11/37:16": {
		"x": 52.39,
		"y": 909.7
	},
	"1/37:16": {
		"x": 43.2,
		"y": 832.16
	},
	"24/37:17": {
		"x": 112.34,
		"y": 865.12
	},
	"11/37:18": {
		"x": 31.22,
		"y": 892.46
	},
	"1/37:18": {
		"x": 82.34,
		"y": 852.18
	},
	"10/37:19": {
		"x": 84.61,
		"y": 896.06
	},
	"11/37:20": {
		"x": 28.76,
		"y": 848.65
	},
	"1/37:20": {
		"x": 89.46,
		"y": 872.36
	},
	"10/37:21": {
		"x": 41.07,
		"y": 901.03
	},
	"11/37:22": {
		"x": 63.83,
		"y": 836.92
	},
	"1/37:22": {
		"x": 107.39,
		"y": 888.59
	},
	"10/37:23": {
		"x": 45.35,
		"y": 876.41
	},
	"11/37:24": {
		"x": 96.57,
		"y": 836.15
	},
	"1/37:24": {
		"x": 68.63,
		"y": 915.12
	},
	"10/37:25": {
		"x": 49.94,
		"y": 852.53
	},
	"10/37:26": {
		"x": 73.2,
		"y": 844.4
	},
	"11/37:26": {
		"x": 56.72,
		"y": 872.56
	},
	"1/37:26": {
		"x": 47.71,
		"y": 864.63
	},
	"8/37:27": {
		"x": 75.68,
		"y": 888.06
	},
	"10/37:28": {
		"x": 36.35,
		"y": 868.48
	},
	"2/37:29": {
		"x": 105.11,
		"y": 844.58
	},
	"24/37:30-31": {
		"x": 66.24,
		"y": 880.65
	},
	"2/37:32-33": {
		"x": 54.78,
		"y": 829.05
	},
	"8/37:34": {
		"x": 109.86,
		"y": 876.85
	},
	"24/37:35": {
		"x": 22.63,
		"y": 884.09
	},
	"8/37:36-43": {
		"x": 87.08,
		"y": 826.56
	},
	"10/37:44-47": {
		"x": 75.66,
		"y": 904.78
	},
	"11/37:44-47": {
		"x": 40.49,
		"y": 844.35
	},
	"1/37:44-47": {
		"x": 92.01,
		"y": 860.13
	},
	"10/37:48-51": {
		"x": 43.14,
		"y": 888.71
	},
	"11/37:48-51": {
		"x": 66.11,
		"y": 823.77
	},
	"24/37:52-53": {
		"x": 87.07,
		"y": 884.31
	},
	"10/37:54-55": {
		"x": 24.97,
		"y": 872.32
	},
	"11/37:54-55": {
		"x": 84.37,
		"y": 840.03
	},
	"1/37:54-55": {
		"x": 63.17,
		"y": 904.43
	},
	"24/37:56": {
		"x": 46.3,
		"y": 820.57
	},
	"7/38:1-54": {
		"x": 200.07,
		"y": 866.42
	},
	"15/39:1-10": {
		"x": 305.05,
		"y": 881.53
	},
	"24/39:11": {
		"x": 346.73,
		"y": 826.61
	},
	"15/39:12-15": {
		"x": 357.83,
		"y": 900.28
	},
	"21/39:16-17": {
		"x": 330.82,
		"y": 858.88
	},
	"15/39:18": {
		"x": 354.76,
		"y": 857.31
	},
	"21/39:19": {
		"x": 319.7,
		"y": 880.73
	},
	"15/39:20-21": {
		"x": 329.46,
		"y": 838.16
	},
	"21/39:22": {
		"x": 331.67,
		"y": 879.94
	},
	"24/39:23": {
		"x": 291.06,
		"y": 881.76
	},
	"15/39:24": {
		"x": 353.4,
		"y": 836.58
	},
	"18/39:25": {
		"x": 345.34,
		"y": 900.59
	},
	"15/39:26": {
		"x": 318.86,
		"y": 859.67
	},
	"18/39:27": {
		"x": 349.46,
		"y": 868.07
	},
	"15/39:28-29": {
		"x": 314.71,
		"y": 891.64
	},
	"18/39:30-31": {
		"x": 334.76,
		"y": 827.4
	},
	"24/39:32": {
		"x": 362.75,
		"y": 888.54
	},
	"15/39:33": {
		"x": 313.56,
		"y": 870.44
	},
	"18/39:34-35": {
		"x": 360.06,
		"y": 846.55
	},
	"15/39:36-37": {
		"x": 333.37,
		"y": 901.37
	},
	"18/39:38-39": {
		"x": 322.79,
		"y": 828.18
	},
	"15/39:40-41": {
		"x": 373.4,
		"y": 866.5
	},
	"2/39:42": {
		"x": 303.33,
		"y": 895.42
	},
	"15/39:43-44": {
		"x": 348.1,
		"y": 847.34
	},
	"2/39:45": {
		"x": 350.84,
		"y": 889.93
	},
	"15/39:46": {
		"x": 312.18,
		"y": 849.71
	},
	"2/39:47": {
		"x": 366.73,
		"y": 856.52
	},
	"15/39:48": {
		"x": 326.68,
		"y": 890.84
	},
	"2/39:49": {
		"x": 337.48,
		"y": 868.84
	},
	"15/39:49": {
		"x": 356.58,
		"y": 878.25
	},
	"2/39:50-53": {
		"x": 299.28,
		"y": 850.56
	},
	"15/39:54": {
		"x": 336.12,
		"y": 848.13
	},
	"2/39:55-57": {
		"x": 338.67,
		"y": 890.62
	},
	"15/39:58": {
		"x": 305.52,
		"y": 839.73
	},
	"2/39:59-60": {
		"x": 361.43,
		"y": 867.28
	},
	"15/39:61": {
		"x": 325.52,
		"y": 869.64
	},
	"2/39:62-63": {
		"x": 341.43,
		"y": 837.37
	},
	"15/39:64-68": {
		"x": 344.14,
		"y": 879.39
	},
	"15/39:69": {
		"x": 306.89,
		"y": 860.47
	},
	"18/39:70-72": {
		"x": 342.79,
		"y": 858.1
	},
	"15/39:73-74": {
		"x": 321.37,
		"y": 901.62
	},
	"24/39:75": {
		"x": 317.49,
		"y": 838.94
	},
	"15/39:76-78": {
		"x": 368.54,
		"y": 877.47
	},
	"22/39:79": {
		"x": 298.57,
		"y": 869.12
	},
	"24/39:80": {
		"x": 324.15,
		"y": 848.91
	},
	"21/40:1-3": {
		"x": 469.62,
		"y": 875.06
	},
	"2/40:4": {
		"x": 440.76,
		"y": 859
	},
	"22/40:5": {
		"x": 495.08,
		"y": 860.9
	},
	"2/40:6": {
		"x": 449.76,
		"y": 881.14
	},
	"22/40:7-8": {
		"x": 459.25,
		"y": 849.5
	},
	"2/40:9": {
		"x": 481.39,
		"y": 877.37
	},
	"22/40:10": {
		"x": 457.93,
		"y": 872.36
	},
	"2/40:11": {
		"x": 476.3,
		"y": 851.29
	},
	"15/40:12-14": {
		"x": 461.45,
		"y": 883.83
	},
	"2/40:15-24": {
		"x": 466.62,
		"y": 861.4
	},
	"7/40:25": {
		"x": 492.39,
		"y": 872.59
	},
	"2/40:26": {
		"x": 438.07,
		"y": 878.45
	},
	"7/40:27-28": {
		"x": 468.65,
		"y": 842.05
	},
	"15/40:29": {
		"x": 473.44,
		"y": 886.42
	},
	"7/40:30": {
		"x": 452.75,
		"y": 859.59
	},
	"15/40:31": {
		"x": 488.29,
		"y": 851.01
	},
	"7/40:32": {
		"x": 453.28,
		"y": 892.61
	},
	"15/40:33": {
		"x": 456.43,
		"y": 837.84
	},
	"7/40:34": {
		"x": 485.22,
		"y": 888.74
	},
	"15/40:35": {
		"x": 446.24,
		"y": 869.67
	},
	"7/40:36": {
		"x": 480.48,
		"y": 840.05
	},
	"15/40:37": {
		"x": 465.27,
		"y": 895.21
	},
	"7/40:38": {
		"x": 447.27,
		"y": 848.91
	},
	"7/40:39-46": {
		"x": 481.92,
		"y": 863.88
	},
	"8/41:1-6": {
		"x": 580.71,
		"y": 886.3
	},
	"8/41:7-8": {
		"x": 601.58,
		"y": 845.4
	},
	"24/41:7-8": {
		"x": 615.15,
		"y": 885.12
	},
	"2/41:9-16": {
		"x": 578.09,
		"y": 872.04
	},
	"8/41:17-18": {
		"x": 609.71,
		"y": 861.8
	},
	"21/41:17-18": {
		"x": 590.39,
		"y": 877.62
	},
	"2/41:19-20": {
		"x": 577.12,
		"y": 846.57
	},
	"8/41:21": {
		"x": 623.35,
		"y": 876.35
	},
	"21/41:21": {
		"x": 588.76,
		"y": 863.77
	},
	"22/41:22": {
		"x": 611.2,
		"y": 838.24
	},
	"2/41:23": {
		"x": 607.76,
		"y": 894.57
	},
	"24/41:24": {
		"x": 577.97,
		"y": 858.54
	},
	"2/41:25-40": {
		"x": 624.7,
		"y": 861.41
	},
	"24/41:41-42": {
		"x": 592.67,
		"y": 891.39
	},
	"2/41:43": {
		"x": 590.79,
		"y": 840.16
	},
	"24/41:44-45": {
		"x": 611.66,
		"y": 873.64
	},
	"2/41:46": {
		"x": 598.7,
		"y": 857.04
	},
	"24/41:47": {
		"x": 612.6,
		"y": 850.15
	},
	"8/41:48-54": {
		"x": 602.37,
		"y": 882.74
	},
	"7/41:55": {
		"x": 587.91,
		"y": 851.81
	},
	"24/41:56-59": {
		"x": 599.87,
		"y": 869.48
	},
	"24/42:1": {
		"x": 688.03,
		"y": 873.77
	},
	"10/42:2": {
		"x": 763.33,
		"y": 890.55
	},
	"11/42:3": {
		"x": 742.59,
		"y": 891.5
	},
	"10/42:4-7": {
		"x": 696.08,
		"y": 854
	},
	"10/42:8": {
		"x": 769.1,
		"y": 823.6
	},
	"11/42:8": {
		"x": 689.61,
		"y": 897.69
	},
	"10/42:9": {
		"x": 705.98,
		"y": 846.37
	},
	"11/42:10": {
		"x": 763.86,
		"y": 902.53
	},
	"10/42:11": {
		"x": 751.83,
		"y": 908.91
	},
	"11/42:12": {
		"x": 757.19,
		"y": 818.52
	},
	"10/42:13": {
		"x": 710.5,
		"y": 922.13
	},
	"11/42:14": {
		"x": 693.08,
		"y": 829.72
	},
	"10/42:15": {
		"x": 762.77,
		"y": 878.55
	},
	"11/42:16": {
		"x": 707.76,
		"y": 858.2
	},
	"10/42:17": {
		"x": 770.41,
		"y": 835.52
	},
	"11/42:18": {
		"x": 720.61,
		"y": 915.68
	},
	"10/42:19": {
		"x": 697.5,
		"y": 866.41
	},
	"11/42:20": {
		"x": 740.7,
		"y": 855.61
	},
	"10/42:21": {
		"x": 731.95,
		"y": 886.02
	},
	"11/42:22-23": {
		"x": 702.29,
		"y": 822.06
	},
	"10/42:24-25": {
		"x": 741.71,
		"y": 915.36
	},
	"11/42:24-25": {
		"x": 720.03,
		"y": 903.63
	},
	"1/42:26-32": {
		"x": 746.29,
		"y": 811.45
	},
	"22/42:33": {
		"x": 762.47,
		"y": 914.45
	},
	"21/42:34": {
		"x": 741.2,
		"y": 903.38
	},
	"22/42:35-36": {
		"x": 715.33,
		"y": 838.86
	},
	"21/42:37-39": {
		"x": 749.22,
		"y": 837.02
	},
	"22/42:40-41": {
		"x": 709.83,
		"y": 884.48
	},
	"24/42:42": {
		"x": 771.26,
		"y": 847.49
	},
	"2/42:43": {
		"x": 676.57,
		"y": 868.74
	},
	"24/42:44": {
		"x": 737.3,
		"y": 831.9
	},
	"2/42:45": {
		"x": 684.65,
		"y": 849.08
	},
	"22/42:46-49": {
		"x": 713.99,
		"y": 826.43
	},
	"24/42:50-52": {
		"x": 773.41,
		"y": 884.06
	},
	"2/42:53": {
		"x": 720.29,
		"y": 878.64
	},
	"1/42:54": {
		"x": 723.15,
		"y": 815.05
	},
	"2/42:55": {
		"x": 760.51,
		"y": 842.24
	},
	"1/42:56": {
		"x": 675.47,
		"y": 856.8
	},
	"2/42:57": {
		"x": 781.19,
		"y": 840.78
	},
	"1/42:58": {
		"x": 709.97,
		"y": 910.15
	},
	"2/42:59": {
		"x": 731.37,
		"y": 874.12
	},
	"1/42:60": {
		"x": 784.06,
		"y": 889.59
	},
	"2/42:61": {
		"x": 688.96,
		"y": 885.73
	},
	"1/42:62": {
		"x": 747.24,
		"y": 825.2
	},
	"2/42:63": {
		"x": 752.35,
		"y": 920.89
	},
	"1/42:64-65": {
		"x": 694.78,
		"y": 841.6
	},
	"2/42:66": {
		"x": 761.34,
		"y": 854.2
	},
	"1/42:67": {
		"x": 698.66,
		"y": 914.82
	},
	"24/42:68-69": {
		"x": 736.47,
		"y": 819.94
	},
	"11/42:70": {
		"x": 753.21,
		"y": 897
	},
	"24/42:71-72": {
		"x": 710.43,
		"y": 896.45
	},
	"10/42:73": {
		"x": 752.13,
		"y": 873.04
	},
	"24/42:74-75": {
		"x": 741.78,
		"y": 927.35
	},
	"10/42:76": {
		"x": 750.56,
		"y": 848.95
	},
	"11/42:76": {
		"x": 772.73,
		"y": 871.89
	},
	"24/42:77-82": {
		"x": 709.44,
		"y": 871.5
	},
	"2/42:83": {
		"x": 751.42,
		"y": 860.93
	},
	"24/42:84": {
		"x": 730.54,
		"y": 897.85
	},
	"2/42:85": {
		"x": 718.84,
		"y": 862.64
	},
	"24/42:86": {
		"x": 782.66,
		"y": 865.15
	},
	"2/42:87": {
		"x": 730.8,
		"y": 862.17
	},
	"24/42:88": {
		"x": 711.2,
		"y": 814.03
	},
	"2/42:89": {
		"x": 741.48,
		"y": 867.57
	},
	"24/42:90": {
		"x": 699.75,
		"y": 890.97
	},
	"2/42:91": {
		"x": 759.17,
		"y": 830.34
	},
	"10/42:92": {
		"x": 720.89,
		"y": 890.61
	},
	"11/42:92": {
		"x": 704.26,
		"y": 834.25
	},
	"24/42:92": {
		"x": 793.31,
		"y": 870.65
	},
	"2/42:93": {
		"x": 700.36,
		"y": 902.96
	},
	"10/42:94": {
		"x": 739.27,
		"y": 843.73
	},
	"11/42:94": {
		"x": 774.49,
		"y": 908.06
	},
	"24/42:94": {
		"x": 686.41,
		"y": 861.88
	},
	"2/42:95": {
		"x": 781.95,
		"y": 852.91
	},
	"10/42:96": {
		"x": 731.13,
		"y": 921.83
	},
	"11/42:96": {
		"x": 729.24,
		"y": 850.34
	},
	"24/42:96": {
		"x": 772.01,
		"y": 859.63
	},
	"2/42:97-98": {
		"x": 678.11,
		"y": 880.62
	},
	"24/42:99": {
		"x": 742.02,
		"y": 879.55
	},
	"11/42:100-101": {
		"x": 752.7,
		"y": 885.03
	},
	"10/42:100-101": {
		"x": 683.65,
		"y": 837.12
	},
	"11/42:102": {
		"x": 792.6,
		"y": 858.43
	},
	"24/42:103-104": {
		"x": 727.31,
		"y": 838.52
	},
	"10/42:105": {
		"x": 726.48,
		"y": 826.55
	},
	"11/42:106": {
		"x": 773.96,
		"y": 896.07
	},
	"1/42:107-108": {
		"x": 673.59,
		"y": 844.4
	},
	"10/42:109": {
		"x": 767.1,
		"y": 811.77
	},
	"1/42:110": {
		"x": 762.1,
		"y": 866.38
	},
	"10/42:111": {
		"x": 717.24,
		"y": 850.73
	},
	"1/42:112": {
		"x": 783.39,
		"y": 877.4
	},
	"10/42:113-114": {
		"x": 678.77,
		"y": 892.6
	},
	"11/42:115": {
		"x": 733.14,
		"y": 808.42
	},
	"10/42:116": {
		"x": 731.07,
		"y": 909.83
	},
	"11/42:117": {
		"x": 698.87,
		"y": 879.01
	},
	"10/42:118": {
		"x": 780.27,
		"y": 828.71
	},
	"1/43:1-9": {
		"x": 59.41,
		"y": 1022.21
	},
	"1/43:10-11": {
		"x": 60.19,
		"y": 976.06
	},
	"24/43:10-11": {
		"x": 78.52,
		"y": 1008.87
	},
	"1/43:12": {
		"x": 57.73,
		"y": 997.92
	},
	"1/43:13": {
		"x": 72.14,
		"y": 975.03
	},
	"24/43:13": {
		"x": 66.68,
		"y": 1010.85
	},
	"1/43:14-29": {
		"x": 48.82,
		"y": 985.85
	},
	"2/43:30-37": {
		"x": 85.04,
		"y": 996.32
	},
	"1/43:38": {
		"x": 54.76,
		"y": 1009.54
	},
	"2/43:39-45": {
		"x": 70.7,
		"y": 998.49
	},
	"1/43:46-48": {
		"x": 84.7,
		"y": 1019.15
	},
	"2/43:49-53": {
		"x": 45.62,
		"y": 1001.01
	},
	"1/43:54-56": {
		"x": 87.17,
		"y": 982.99
	},
	"2/43:57": {
		"x": 72.87,
		"y": 1021.12
	},
	"1/43:58": {
		"x": 63.73,
		"y": 987.52
	},
	"2/43:58": {
		"x": 90.51,
		"y": 1008.65
	},
	"2/43:59": {
		"x": 43.37,
		"y": 1013.31
	},
	"1/43:60": {
		"x": 75.69,
		"y": 986.49
	},
	"7/44:1": {
		"x": 207.1,
		"y": 1011.57
	},
	"2/44:2": {
		"x": 185.86,
		"y": 987.97
	},
	"7/44:3": {
		"x": 217.14,
		"y": 993.37
	},
	"2/44:4": {
		"x": 196.6,
		"y": 1005.77
	},
	"7/44:5": {
		"x": 196.14,
		"y": 981.78
	},
	"2/44:6": {
		"x": 217.37,
		"y": 1005.37
	},
	"7/44:7": {
		"x": 186.09,
		"y": 999.97
	},
	"2/44:8": {
		"x": 206.64,
		"y": 987.57
	},
	"7/44:9": {
		"x": 196.83,
		"y": 1017.76
	},
	"2/44:10": {
		"x": 196.37,
		"y": 993.77
	},
	"7/44:11": {
		"x": 206.87,
		"y": 999.57
	},
	"2/44:12": {
		"x": 186.32,
		"y": 1011.97
	},
	"22/45:1": {
		"x": 330.11,
		"y": 960.97
	},
	"24/45:2": {
		"x": 355.13,
		"y": 1034.57
	},
	"1/45:3": {
		"x": 326.46,
		"y": 1006.43
	},
	"24/45:4": {
		"x": 355.35,
		"y": 986.13
	},
	"1/45:5-6": {
		"x": 335.31,
		"y": 1027.36
	},
	"1/45:7": {
		"x": 318.92,
		"y": 965.3
	},
	"24/45:7": {
		"x": 371.45,
		"y": 1003.36
	},
	"1/45:8-9": {
		"x": 330.24,
		"y": 995.07
	},
	"24/45:10": {
		"x": 337.61,
		"y": 970.33
	},
	"1/45:11-13": {
		"x": 338.19,
		"y": 1004.02
	},
	"24/45:14": {
		"x": 318.5,
		"y": 997.45
	},
	"1/45:15-18": {
		"x": 366.56,
		"y": 980.61
	},
	"24/45:19": {
		"x": 314.72,
		"y": 1008.83
	},
	"1/45:20": {
		"x": 326.43,
		"y": 974.64
	},
	"1/45:21": {
		"x": 327.36,
		"y": 1018.38
	},
	"15/45:21": {
		"x": 306.5,
		"y": 1000.11
	},
	"24/45:22": {
		"x": 345.4,
		"y": 979.45
	},
	"1/45:23-24": {
		"x": 339.1,
		"y": 1015.98
	},
	"24/45:25": {
		"x": 314.58,
		"y": 976.49
	},
	"1/45:26-27": {
		"x": 372.79,
		"y": 991.44
	},
	"24/45:28": {
		"x": 311.8,
		"y": 1032.17
	},
	"1/45:29-30": {
		"x": 348.25,
		"y": 964.78
	},
	"2/45:29-30": {
		"x": 343.27,
		"y": 1036.34
	},
	"22/45:29-30": {
		"x": 302.53,
		"y": 978.25
	},
	"1/45:31-36": {
		"x": 343.95,
		"y": 992.37
	},
	"24/45:37": {
		"x": 323.56,
		"y": 1029.76
	},
	"1/45:38-40": {
		"x": 322.43,
		"y": 985.96
	},
	"24/45:41-42": {
		"x": 367.32,
		"y": 1014.61
	},
	"2/45:43-70": {
		"x": 298.24,
		"y": 1016.09
	},
	"1/45:71": {
		"x": 356.02,
		"y": 973.91
	},
	"24/45:71": {
		"x": 347.06,
		"y": 1024.96
	},
	"1/45:72-76": {
		"x": 310.13,
		"y": 988.17
	},
	"24/45:77-79": {
		"x": 361.8,
		"y": 996.23
	},
	"1/45:80": {
		"x": 315.61,
		"y": 1020.79
	},
	"24/45:81-83": {
		"x": 334.22,
		"y": 983.76
	},
	"1/45:84": {
		"x": 358.93,
		"y": 1023.2
	},
	"24/45:85-87": {
		"x": 298.1,
		"y": 991.54
	},
	"1/45:88": {
		"x": 366.53,
		"y": 968.11
	},
	"1/45:89": {
		"x": 331.51,
		"y": 1038.74
	},
	"8/45:89": {
		"x": 307.06,
		"y": 967.14
	},
	"1/45:90-107": {
		"x": 352.9,
		"y": 1008.92
	},
	"3/46:1-3": {
		"x": 473.8,
		"y": 988.16
	},
	"3/46:4-6": {
		"x": 479.74,
		"y": 968.15
	},
	"24/46:4-6": {
		"x": 441.17,
		"y": 1032.97
	},
	"1/46:7": {
		"x": 430.5,
		"y": 986.19
	},
	"10/46:8-9": {
		"x": 501.54,
		"y": 965.33
	},
	"3/46:10-12": {
		"x": 444.66,
		"y": 1001.39
	},
	"24/46:10-12": {
		"x": 445.23,
		"y": 958.03
	},
	"1/46:13": {
		"x": 508.8,
		"y": 1026.04
	},
	"11/46:14-16": {
		"x": 421.72,
		"y": 994.36
	},
	"3/46:17-19": {
		"x": 470.2,
		"y": 1020.24
	},
	"24/46:17-19": {
		"x": 512.67,
		"y": 1014.22
	},
	"8/46:20-21": {
		"x": 436.49,
		"y": 966.24
	},
	"1/46:22-23": {
		"x": 514.21,
		"y": 998.49
	},
	"1/46:24-25": {
		"x": 438.52,
		"y": 1021.26
	},
	"22/46:24-25": {
		"x": 465.31,
		"y": 953.2
	},
	"21/46:26": {
		"x": 456.13,
		"y": 1004.89
	},
	"7/46:27": {
		"x": 447.33,
		"y": 1013.09
	},
	"21/46:28": {
		"x": 504.46,
		"y": 1005.48
	},
	"7/46:29-31": {
		"x": 443.83,
		"y": 1044.67
	},
	"24/46:32": {
		"x": 482.45,
		"y": 979.81
	},
	"7/46:33": {
		"x": 500.99,
		"y": 1016.95
	},
	"6/46:34": {
		"x": 424.4,
		"y": 1006.04
	},
	"5/46:34": {
		"x": 492.16,
		"y": 972.8
	},
	"4/46:34": {
		"x": 489.23,
		"y": 1019.25
	},
	"7/46:35-36": {
		"x": 439.27,
		"y": 978.02
	},
	"7/46:37": {
		"x": 450.75,
		"y": 981.52
	},
	"24/46:37": {
		"x": 449.96,
		"y": 1024.82
	},
	"7/46:38": {
		"x": 468.22,
		"y": 964.84
	},
	"7/46:39": {
		"x": 499.19,
		"y": 1040.14
	},
	"8/46:39": {
		"x": 441.97,
		"y": 989.7
	},
	"7/46:40": {
		"x": 459.42,
		"y": 973.23
	},
	"7/46:41": {
		"x": 471.3,
		"y": 1035.17
	},
	"8/46:41": {
		"x": 453.44,
		"y": 993.21
	},
	"7/46:42": {
		"x": 485.6,
		"y": 991.35
	},
	"7/46:43": {
		"x": 435.88,
		"y": 1009.57
	},
	"8/46:43": {
		"x": 476.84,
		"y": 956.51
	},
	"7/46:44": {
		"x": 487.9,
		"y": 1036.12
	},
	"7/46:45": {
		"x": 419.02,
		"y": 982.68
	},
	"24/46:45": {
		"x": 495.32,
		"y": 984.37
	},
	"7/46:46-47": {
		"x": 479.33,
		"y": 1012.51
	},
	"7/46:48": {
		"x": 456.69,
		"y": 961.55
	},
	"24/46:48": {
		"x": 497.03,
		"y": 1028.34
	},
	"7/46:49-51": {
		"x": 461.42,
		"y": 1028.37
	},
	"7/46:52": {
		"x": 470.94,
		"y": 976.53
	},
	"24/46:52": {
		"x": 462.51,
		"y": 1043.33
	},
	"7/46:53": {
		"x": 464.9,
		"y": 996.7
	},
	"3/46:54": {
		"x": 506.1,
		"y": 989.65
	},
	"7/46:55-56": {
		"x": 458.76,
		"y": 1016.68
	},
	"7/46:57": {
		"x": 467.55,
		"y": 1008.55
	},
	"24/46:57": {
		"x": 480.09,
		"y": 1027.01
	},
	"7/46:58-60": {
		"x": 433.19,
		"y": 997.87
	},
	"24/46:61": {
		"x": 496.36,
		"y": 996.66
	},
	"7/46:62": {
		"x": 452.63,
		"y": 1036.53
	},
	"24/46:63": {
		"x": 447.95,
		"y": 969.76
	},
	"7/46:64-65": {
		"x": 489.86,
		"y": 1006.74
	},
	"24/46:66": {
		"x": 427.07,
		"y": 1017.73
	},
	"7/46:67-68": {
		"x": 489.45,
		"y": 961.12
	},
	"7/46:69": {
		"x": 479.1,
		"y": 1044.28
	},
	"24/46:69": {
		"x": 427.8,
		"y": 974.51
	},
	"7/46:70-74": {
		"x": 505.54,
		"y": 977.17
	},
	"7/46:75": {
		"x": 429.72,
		"y": 1029.43
	},
	"24/46:75": {
		"x": 462.23,
		"y": 985.01
	},
	"24/46:76-80": {
		"x": 476.9,
		"y": 1000.25
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/line_song_positions.json
 ** module id = 213
 ** module chunks = 0
 **/